import { Logger, Auth, JS } from 'aws-amplify';
import { Utils, SecurityUtils, moment } from 'revlock-webutils';
import * as AuthUtils from 'utils/auth';
import { isImpersonatedUser, licensedExecute } from 'utils/auth';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import { AuthPiece } from 'aws-amplify-react';
import * as WebUtils from 'utils/WebUtils';
import { compose } from 'utils/WebUtils';
import classNames from 'classnames';
import { Grid, LinearProgress, Backdrop, MuiThemeProvider, Fade, Card, CardContent, Typography, Button, Divider, TextField, InputAdornment, IconButton, Box, CardActions, Dialog, Slide, Tooltip, CircularProgress, Container, Tabs, Tab, FormControl, Switch, FormHelperText, withWidth, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogActions, Chip, Paper as Paper$1, InputLabel, Select, Input, MenuItem, Checkbox, ListItemText as ListItemText$1, Table, TableHead, TableRow, TableCell, TableSortLabel, TableBody, Avatar, CardHeader, Badge } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Carousel from 'react-material-ui-carousel';
import { withStyles, createMuiTheme, makeStyles } from '@material-ui/core/styles';
import { Visibility, VisibilityOff, Check, Close, FiberManualRecord, ArrowBack, LockOpen, Lock, Info, PolicyOutlined, People, DeleteForeverSharp, Delete, Add } from '@material-ui/icons';
import queryString from 'query-string';
import * as API from 'rest/API';
import base64 from 'base-64';
import shortid from 'shortid';
import * as ChargebeeUtil from 'utils/ChargebeeUtils';
import config from 'cfg/config';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { green, red, lightBlue } from '@material-ui/core/colors';
import swal from 'sweetalert';
import OtpInput from 'react-otp-input';
import SwipeableViews from 'react-swipeable-views';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import MuiPhoneNumber from 'material-ui-phone-number';
import PropTypes from 'prop-types';
import EditableLabel from 'components/EditableLabel';
import ReactSelect from 'react-select';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import '@material-ui/core/colors/grey';

const logoImage = "https://cdn.revrec.chargebee.com/images/chargebee_logo.svg";
const globalStyles = theme => ({
  buttonRoot: {
    display: "flex",
    alignItems: "center"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  root: {
    // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: "white",
    height: 48,
    padding: "0 30px"
  },
  signUpContainer: {
    marginTop: 68,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      maxWidth: 480,
      marginBottom: theme.spacing(1)
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 640,
      marginBottom: theme.spacing(4)
    }
  },
  card: {
    margin: 8,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1)
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(2)
    }
  },
  background: {
    minHeight: "100vh",
    height: "100%",
    // background: 'url(/chargebee-icon-black.png) no-repeat center center rgba(0,0,0,.05)',
    backgroundSize: 300
  },
  ["login-actions"]: {
    justifyContent: "space-between"
  },
  ["lock-actions"]: {
    justifyContent: "space-between"
  },
  ["signup-content"]: {
    // textAlign: 'center'
  },
  logo: {
    height: 60,
    marginBottom: 10,
    [theme.breakpoints.down("md")]: {
      height: 60
    }
  },
  ["signup- logo"]: {
    height: 54,
    marginBottom: 10
  },
  error: {
    fontSize: "12px",
    color: "#de3618"
  },
  resendButton: {
    marginLeft: 16,
    backgroundColor: "#de3618",
    color: "white"
  },
  resendDisabled: {
    backgroundColor: "grey"
  },
  mainMessage: {
    fontWeight: 400
  }
});

const logger$2 = new Logger("SignIn");
const signinBottomImage$1 = "https://cdn.revrec.chargebee.com/images/signup/linePatternBottom.svg";
const signinTopImage$1 = "https://cdn.revrec.chargebee.com/images/signup/linePatternTop.svg";
var items$1 = [{
  image: "https://cdn.revrec.chargebee.com/images/signup/singin1.svg"
}, {
  image: "https://cdn.revrec.chargebee.com/images/signup/signin2.svg"
}, {
  image: "https://cdn.revrec.chargebee.com/images/signup/signin3.svg"
}];
const signInStyles = theme => {
  const result = {
    parent: {
      display: "flex",
      justifyContent: "space-around",
      position: "relative",
      flex: 1,
      "& .MuiCardActions-root": {
        paddingLeft: "22px",
        paddingRight: "22px"
      }
    },
    signUpWidget: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      zIndex: 1,
      top: 0,
      right: 0,
      padding: "16px 8px"
    },
    actions: {
      justifyContent: "space-between"
    },
    google: {
      fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif;'
    },
    googleLogoBox: {
      width: theme.spacing(3)
    },
    googleLogo: {
      width: 16,
      padding: 9
    },
    googleBox: {
      paddingLeft: "0.1px",
      // backgroundColor: '#4285F4',
      display: "flex",
      justifyContent: "center",
      border: "1px solid grey"
    },
    loginDivider: {
      height: 1,
      margin: theme.spacing(1),
      background: "#dcdce1",
      display: "block",
      textAlign: "center",
      position: "relative"
    },
    loginDividerText: {
      top: "-10px",
      backgroundColor: "white",
      padding: "0 6px",
      display: "inline-block"
    },
    pt14: {
      paddingTop: "14px !important"
    },
    divider: {
      marginTop: "5.6%"
    },
    p0: {
      padding: "0 !important"
    },
    pl2: {
      paddingLeft: 2
    },
    taCenter: {
      textAlign: "center"
    },
    main: {
      paddingTop: 16
      // color:'#818195'
    },
    forgotPassword: {
      textAlign: "end",
      color: "#2d6a8a"
    },
    button: {
      minHeight: "42px"
    },
    signUp: {
      display: "flex",
      justifyContent: "center",
      color: "#818195"
    },
    cursorPointer: {
      cursor: "pointer"
    },
    carousal: {
      backgroundColor: "#012a38"
    },
    signinTopImage: {
      textAlign: "right",
      maxHeight: "200px"
    },
    taLeft: {
      textAlign: "left"
    },
    textWhite: {
      color: "white"
    },
    heading: {
      fontSize: "16px",
      fontWeight: "500",
      marginBottom: "0",
      color: "#676770"
    },
    headingMain: {
      color: "#012a38"
    },
    bottomImg: {
      position: "absolute",
      bottom: "8px",
      left: "50%"
    },
    regionSwitcher: {
      textAlign: "center",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1)
    },
    regionLink: {
      color: "#2d6a8a",
      cursor: "pointer",
      textDecoration: "underline"
    },
    ...globalStyles(theme)
  };
  return result;
};
class SignIn extends AuthPiece {
  constructor(props) {
    super(props);
    //window.LOG_LEVEL = 'DEBUG';
    this.getCurrentRegion = () => {
      const {
        backend
      } = config;
      if (backend === "prod-eu" || backend === "dev-eu") {
        return "EU";
      } else if (backend === "prod" || backend === "qa") {
        return "US";
      } else if (backend === "dev") {
        return "US"; // US dev - will be hidden
      } else {
        // For local development/testing
        return "US";
      }
    };
    this.shouldShowRegionSwitcher = () => {
      const {
        backend
      } = config;
      // Don't show for US dev, show for all others including local
      return backend !== "dev";
    };
    this.getRegionSwitchUrl = () => {
      const {
        backend
      } = config;

      // For local development - toggle between localhost with different backends
      if (backend === "dev" || !config.isCloudDeployment) {
        const currentUrl = new URL(window.location.href);
        const currentBackend = currentUrl.searchParams.get("backend") || "prod";
        const newBackend = currentBackend === "prod" ? "prod-eu" : "prod";
        currentUrl.searchParams.set("backend", newBackend);
        return currentUrl.toString();
      }

      // Use getTargetRegionConfig to get the target region's config
      const targetConfig = config.getTargetRegionConfig(backend);
      return targetConfig.AWS.oauth.redirectSignIn;
    };
    this.handleRegionSwitch = () => {
      try {
        const switchUrl = this.getRegionSwitchUrl();
        window.location.href = switchUrl;
      } catch (error) {
        console.error("Error switching regions:", error);
        // Don't switch - just log the error and stay on current page
      }
    };
    this.attemptAutoSignIn = async (login, password, creParams = {}) => {
      const cAuthUser = await Auth.currentUserInfo();
      if (!cAuthUser || !cAuthUser.id) {
        let {
          autoLoginAttempts
        } = this.state;
        if (!autoLoginAttempts) {
          autoLoginAttempts = [];
        }
        const hasAttempted = autoLoginAttempts.find(a => a == login);
        if (hasAttempted) {
          return;
        }
        try {
          this.inputs = this.inputs || {};
          this.inputs["username"] = login;
          this.inputs["password"] = password;
          autoLoginAttempts = autoLoginAttempts.concat([login]);
          this.setState({
            showLogin: false,
            autoLogin: true,
            autoLoginAttempts
          });
          this.signIn(login, password, creParams, () => {
            this.setState({
              autoLogin: false,
              showLogin: true
            });
          });
        } catch (err) {
          console.error(err);
        }
      } else {
        console.log("Refuse to auto-login");
      }
    };
    this.canSignup = async params => {
      if (!params.signUp) {
        try {
          const {
            cookies
          } = this.props;
          const resp = await API.getMode();
          cookies.set("appModeResponse", resp, {
            path: "/"
          });
          return false;
        } catch (err) {
          console.log(err);
        }
      }
      const {
        updatingSignup
      } = this.state;
      if (updatingSignup) {
        return;
      }
      this.setState({
        updatingSignup: true
      });
      const {
        canSignup
      } = this.props;
      if (canSignup) {
        const result = await canSignup(this.props.cookies);
        this.setState({
          canSignup: result,
          updatingSignup: false
        });
      }
    };
    this.chargebeeIdpLogin = async params => {
      function clearQueryParams(history) {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.has("jwt")) {
          queryParams.delete("jwt");
          queryParams.delete("data");
          history.replace({
            search: queryParams.toString()
          });
        }
      }
      const {
        jwt,
        data,
        clientId,
        redirectUrl
      } = params;
      let dataObj = JSON.parse(atob(data));
      try {
        this.setState({
          loading: true
        });

        // {email} is passed dataObj.
        let {
          email
        } = dataObj;
        email = Utils.normalizeEmail(email);
        await Auth.configure({
          authenticationFlowType: "CUSTOM_AUTH"
        });
        let user = await Auth.signIn(email, null, {
          chargebeeSignIn: "true"
        });
        if (user.challengeName === "CUSTOM_CHALLENGE") {
          let revrecUiSessionId = shortid.generate();
          const challengeAnswer = {
            email,
            jwt,
            revrecUiSessionId
          };
          if (clientId) {
            challengeAnswer.clientId = clientId;
          }
          if (redirectUrl) {
            challengeAnswer.returnPath = redirectUrl;
          }
          user = await Auth.sendCustomChallengeAnswer(user, JSON.stringify(challengeAnswer));
          ChargebeeUtil.setChargebeeUISession(revrecUiSessionId);
          this.changeState("signedIn", user);
          clearQueryParams(this.props.history);
        } else {
          this.checkContact(user);
        }
      } catch (err) {
        console.log("Catch Error");
        console.error(err);
        if (err.code === "PasswordResetRequiredException") {
          this.setState({
            error: null
          });
          //clear the error
          this.changeState("forgotPassword", {
            username,
            adminReset: true
          });
        }
        if (err.code === "UserNotConfirmedException") {
          logger$2.debug("the user is not confirmed");
          this.changeState("confirmSignUp", {
            username
          });
        } else {
          this.errorHandler(err);
          this.setState({
            autoLogin: false
          });
          setTimeout(() => this.setState({
            showLogin: true
          }), 1000);
        }
        clearQueryParams(this.props.history);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.updateSignoutMessage = () => {
      const signoutMessage = localStorage.getItem("signoutMessage");
      if (signoutMessage) {
        this.errorHandler({
          message: signoutMessage
        });
        setTimeout(() => localStorage.removeItem("signoutMessage"), 5000);
      }
    };
    this.onKeyDown = e => {
      if (this.props.authState === "signIn") {
        if (e.keyCode === 13 || e.key === "Enter") {
          if (this.state.isRevrecUser) this.signIn();else this.checkUserIdp();
        }
      }
    };
    this.checkContact = user => {
      Auth.verifiedContact(user).then(data => {
        if (!JS.isEmpty(data.verified)) {
          this.changeState("signedIn", user);
        } else {
          user = Object.assign(user, data);
          this.changeState("verifyContact", user);
        }
      });
    };
    this.onInputChange = event => {
      const {
        name,
        value
      } = event.target;
      this.setState({
        [name]: value
      });
      this.handleInputChange(event);
    };
    this.signIn = async (username, password, creParams = {}, callback) => {
      const {
        customAuthToken
      } = creParams;
      username = username || this.inputs.username;
      password = password || this.inputs.password;
      if (!username || !username.length) {
        this.errorHandler({
          message: "Missing or incomplete username"
        });
        return;
      }

      // If no custom auth then check the password is valid.
      if (!customAuthToken && (!password || password.length < 6)) {
        this.errorHandler({
          message: "Missing or incomplete password"
        });
        return;
      }
      if (username.indexOf(" ") >= 0) {
        this.errorHandler({
          message: "Email Address cannot contain spaces"
        });
        return;
      }
      try {
        this.setState({
          loading: true
        });
        if (customAuthToken) {
          // {email} is passed in cre as a query param.
          // We can't use username here becuase for externally authenticated users,
          // username is not the email.
          // For e.g. for google user username is like "google_!@#$"
          const {
            email
          } = creParams;
          this.setState({
            loading: true
          });
          await Auth.configure({
            authenticationFlowType: "CUSTOM_AUTH"
          });
          let user = await Auth.signIn(username, null, {
            chargebeeSignIn: "true"
          });
          if (user.challengeName === "CUSTOM_CHALLENGE") {
            user = await Auth.sendCustomChallengeAnswer(user, JSON.stringify({
              email,
              customAuthToken
            }));
            console.log("user", user);
            this.changeState("signedIn", user);
          } else {
            this.checkContact(user);
          }
        } else {
          console.log("SignIn Type password");
          const user = await Auth.signIn(username, password, {
            signInType: "password"
          });
          if (user.challengeName === "SMS_MFA" || user.challengeName === "SOFTWARE_TOKEN_MFA") {
            logger$2.debug("confirm user with " + user.challengeName);
            this.changeState("confirmSignIn", user);
          } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            logger$2.debug("require new password", user.challengeParam);
            this.changeState("requireNewPassword", user);
          } else if (user.challengeName === "MFA_SETUP") {
            logger$2.debug("TOTP setup", user.challengeParam);
            this.changeState("TOTPSetup", user);
          } else {
            this.checkContact(user);
          }
        }
      } catch (err) {
        if (err.code === "PasswordResetRequiredException") {
          this.setState({
            error: null
          });
          //clear the error
          this.changeState("forgotPassword", {
            username,
            adminReset: true
          });
        }
        if (err.code === "UserNotConfirmedException") {
          logger$2.debug("the user is not confirmed");
          this.changeState("confirmSignUp", {
            username
          });
        } else {
          this.errorHandler(err);
        }
      } finally {
        this.setState({
          loading: false
        }, callback);
      }
    };
    this.cbSSOAutoLogin = async callback => {
      try {
        // changing to loading state
        this.setState({
          loading: true,
          loginInfo: "Attempting to Login to RevRec"
        });

        // authenticating user via keycloak, initializing kk sso auth
        const keycloak = await AuthUtils.initKeycloak();
        const {
          authenticated,
          tokenParsed,
          token
        } = keycloak;
        if (authenticated) {
          const email = Utils.normalizeEmail(tokenParsed.email);
          const {
            actualUsername
          } = await API.getActualUsername({
            username: email
          });
          this.setState({
            loading: true,
            loginInfo: "User is authenticated, now checking access to RevRec"
          });

          // We need to use the email out from keycloak authenticated token
          // & use this to create a OTP for aws amplify to work with aws cognito
          await Auth.configure({
            authenticationFlowType: "CUSTOM_AUTH"
          });
          let user = await Auth.signIn(actualUsername, null);
          if (user.challengeName === "CUSTOM_CHALLENGE") {
            try {
              user = await Auth.sendCustomChallengeAnswer(user, JSON.stringify({
                email: actualUsername,
                keycloak: {
                  token
                }
              }));
              logger$2.info(`User signedId ${JSON.stringify(user)}`);
              this.changeState("signedIn", user);
            } catch (error) {
              // since user is authenticated by kk sso & user not
              // exists in aws cognito then create user in aws for otp
              if (error.code == "NotAuthorizedException") {
                this.setState({
                  loading: true,
                  loginInfo: "No RevRec Access for User, Finding User Invite"
                });
                try {
                  // creating new cognito user, from user invites
                  await API.createNewUser({
                    token,
                    username: email,
                    idpProvider: tokenParsed.identity_provider
                  });
                } catch (err) {
                  if (err.subCode == "ERR_USER_NOT_INVITED") {
                    // error while creating user, invite not found..
                    // notify user, to contact support for invite.
                    this.setState({
                      loading: true,
                      loginInfo: `User '${email}' exists in Chargebee but is not invited to any environment in RevRec,
                                            please reachout to Customer Support for access.`
                    });
                    setTimeout(() => this.setState({
                      autoLogin: false,
                      showLogin: true
                    }), 1000);
                    return;
                  } else {
                    WebUtils.showError(Object.assign({}, err, {
                      buttons: "Close"
                    }));
                    setTimeout(() => this.setState({
                      autoLogin: false,
                      showLogin: true
                    }), 1000);
                  }
                }

                // refreshing the page again as now the new user is
                // created, so the amplify will be initialized.
                // window.location.reload();
                const {
                  actualUsername
                } = await API.getActualUsername({
                  username: email
                });

                // We need to use the email out from keycloak authenticated token
                // & use this to create a OTP for aws amplify to work with aws cognito
                await Auth.configure({
                  authenticationFlowType: "CUSTOM_AUTH"
                });
                let user = await Auth.signIn(actualUsername, null);
                try {
                  user = await Auth.sendCustomChallengeAnswer(user, JSON.stringify({
                    email: actualUsername,
                    keycloak: {
                      token
                    }
                  }));
                  logger$2.info(`User signedId ${JSON.stringify(userchanter)}`);
                  this.changeState("signedIn", user);
                } catch (error) {
                  if (error.code == "NotAuthorizedException") {
                    logger$2.error(`Unable to authenticate user ${email}`);
                  }
                  throw error;
                }
              } else {
                throw error;
              }
            }
          } else {
            this.checkContact(user);
          }
        } else {
          logger$2.info(`Unable to Sign In using keycloak credentials`);
        }
      } catch (error) {
        logger$2.error("Keycloak: Failed to initialize adapter:", error);
      } finally {
        this.setState({
          loading: false
        }, callback);
      }
    };
    this.cbSSOSignIn = async callback => {
      try {
        // changing to loading state
        this.setState({
          loading: true
        });

        // login user via keycloak
        const authenticated = await AuthUtils.loginKeycloak();
        if (!authenticated) {
          throw Error(`Unable to authenticate user.`);
        } else {
          // We might have being redirected back to the page after authentication
          await cbSSOAutoLogin();
        }
      } catch (error) {
        logger$2.debug("Keycloak: Failed to initialize adapter:", error);
      } finally {
        this.setState({
          loading: false
        }, callback);
      }
    };
    this.googleSignIn = () => {
      const {
        config
      } = this.props;
      const {
        oauth
      } = config.AWS;
      const {
        userPoolWebClientId
      } = config.AWS.Auth;
      let url = `https://${oauth.domain}/oauth2/authorize?identity_provider=Google&redirect_uri=${oauth.redirectSignIn}&response_type=CODE&client_id=${userPoolWebClientId}&scope=aws.cognito.signin.user.admin email openid phone profile`;
      window.location.href = url;
    };
    this.errorHandler = error => {
      if (error) {
        this.setState({
          error
        });
      } else {
        this.setState({
          error: undefined
        });
      }
    };
    this.handleClickShowPassword = event => {
      const {
        showPassword
      } = this.state;
      this.setState({
        showPassword: !showPassword
      });
    };
    this.handleMouseDownPassword = event => {
      event.preventDefault();
    };
    this.checkUserIdp = async (email, clientId, revrecPath, fromChargebee = false) => {
      // Same query params as login_hint path; Continue otherwise drops them.
      const params = window.location.search && queryString.parse(window.location.search) || {};
      if (!clientId) {
        clientId = params.clientId;
      }
      if (!revrecPath) {
        const fromQuery = params.redirectUrl;
        if (typeof fromQuery === "string" && fromQuery.startsWith("/") && !fromQuery.startsWith("//") && !fromQuery.includes("://")) {
          revrecPath = fromQuery;
        }
      }
      if (!clientId) {
        const pathOrgId = (window.location.pathname || "").split("/").filter(Boolean)[0];
        if (pathOrgId && !isNaN(pathOrgId)) {
          clientId = pathOrgId;
        }
      }
      if (!revrecPath && clientId && (window.location.pathname === `/${clientId}` || window.location.pathname.startsWith(`/${clientId}/`))) {
        revrecPath = window.location.pathname;
      }
      let username = email || this.state.username;
      if (!username || !username.length) {
        this.errorHandler({
          message: "Missing or incomplete username"
        });
        return;
      }
      if (username.indexOf(" ") >= 0) {
        this.errorHandler({
          message: "Email Address cannot contain spaces"
        });
        return;
      }
      this.setState({
        loading: true
      });
      try {
        let {
          idp,
          type,
          redirectUrl
        } = await API.getUserIdp(username, clientId, revrecPath);
        if (!idp) {
          this.errorHandler({
            message: `This user with email id ${username} don't exist in our system. Please verify the email address.`
          });
        }
        if (idp === "revrec-idp") {
          this.setState({
            isRevrecUser: true
          });
          if (fromChargebee) {
            this.inputs.username = email;
            this.setState({
              autoLogin: false
            });
            setTimeout(() => this.setState({
              showLogin: true
            }), 1000);
          }
          return;
        }
        if (idp === "chargebee-idp") {
          if (type === "redirect") {
            window.location.href = redirectUrl;
            return;
          } else {
            this.errorHandler({
              message: "This email is signed up from Chargebee. " + "Please, Go to <a href='app.chargebee.com'>app.chargebee.com</a> -> Login -> Click on Revrec in the Left Menu to automatically log in to Revrec."
            });
            return;
          }
        }
        if (idp === "google-idp") {
          this.googleSignIn();
          return;
        }
      } catch (e) {
        this.setState({
          isRevrecUser: false
        });
      } finally {
        this.setState({
          loading: false
        });
      }
      this.setState({
        autoLogin: false
      });
      setTimeout(() => this.setState({
        showLogin: true
      }), 1000);
    };
    const _params = window.location.search && queryString.parse(window.location.search) || {};
    let {
      cbsso
    } = _params;
    cbsso = cbsso && cbsso === "true" || window.location.origin.match(/-sso.revrec/) && window.location.origin.match(/-sso.revrec/).length > 0;
    this._validAuthStates = ["signIn", "signedOut", "signedUp"];
    this.state = {
      loading: false,
      autoLogin: cbsso,
      username: "",
      password: "",
      showPassword: false,
      canSignup: false,
      updatingSignup: false,
      isRevrecUser: false,
      cbsso,
      loginInfo: undefined,
      hasCheckedSignoutMessage: false,
      currentRegion: this.getCurrentRegion(),
      showRegionSwitcher: this.shouldShowRegionSwitcher()
    };
  }
  componentDidMount() {
    const doDemoSignin = async () => {
      const de = await API.getDemoEnvironmentDetails();
      const e = de && de.find(e => e.env === params.env);
      if (e) {
        const {
          username,
          password
        } = e;
        return this.attemptAutoSignIn(username, base64.decode(password));
      }
    };
    const doInviteSignUp = async () => {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (e) {
        setTimeout(() => this.changeState("signUp"), 500);
      } finally {
        setTimeout(() => this.setState({
          autoLogin: false,
          showLogin: true
        }), 1000);
      }
    };
    const params = window.location.search && queryString.parse(window.location.search) || {};
    let {
      login,
      env,
      cre,
      temporaryPassword: password,
      cbssoredirect,
      jwt,
      signUp,
      signout,
      login_hint
    } = params;
    const {
      cbsso,
      loginInfo
    } = this.state;
    if (signout == "true") {
      //redirecting to cognito logout to clear cookies & show the sign-in page
      const {
        config
      } = this.props;
      const {
        redirectSignoutUri
      } = config.keycloakConfig;
      window.location.assign(redirectSignoutUri);
      return;
    }

    // Only check for signout message if we haven't already
    if (!this.state.hasCheckedSignoutMessage) {
      this.updateSignoutMessage();
      this.setState({
        hasCheckedSignoutMessage: true
      });
    }
    this.canSignup(params);
    if (cre) {
      console.error("!!!! CRE PROCESSING (SIGN IN) !!!! ");
      try {
        const data = atob(cre);
        const creParams = JSON.parse(data);
        const customAuthToken = creParams.customAuthToken;
        const login = creParams.login;
        const temporaryPassword = creParams.temporaryPassword;
        if (login && customAuthToken) {
          return this.attemptAutoSignIn(login, undefined, creParams);
        }
        if (!creParams.invite && login && temporaryPassword) {
          return this.attemptAutoSignIn(login, temporaryPassword);
        }
        if (login && creParams.invite) {
          return doInviteSignUp();
        }
      } catch (e) {
        console.log("Failed to get credentials", e);
      }
    } else if (jwt) {
      return this.chargebeeIdpLogin(params);
    } else if (login_hint) {
      let {
        clientId,
        redirectUrl
      } = params;
      return this.checkUserIdp(login_hint.toLowerCase(), clientId, redirectUrl, true);
    }
    //new login on token
    else if (login && password) {
      return this.attemptAutoSignIn(login, password); //legacy auto-login
    } //demo login
    else if (env) {
      return doDemoSignin();
    } //no auto-login
    else if (cbssoredirect && !loginInfo) {
      return this.cbSSOAutoLogin();
    } else if (cbsso && !signUp && !loginInfo) {
      return this.cbSSOSignIn();
    }
    this.setState({
      autoLogin: false
    });
    setTimeout(() => this.setState({
      showLogin: true
    }), 1000);
  }
  componentDidUpdate() {
    const {
      authData
    } = this.props;
    const {
      error
    } = this.state;
    const resetErrors = authData && authData.resetErrors || false;
    const justSetPassword = authData && authData.justSetPassword || false;
    const username = authData && authData.username || null;
    const password = authData && authData.password || null;
    if (resetErrors && error && error.message) {
      this.setState({
        error: null
      });
    }
    //if the errors need to be cleared do it

    if (justSetPassword && username && !password && !this.inputs["username"]) {
      this.inputs["username"] = username;
      this.setState({
        username
      });
    }
    //if the username is already set from the forgot password form

    if (justSetPassword && username && password && !this.inputs["username"]) {
      this.inputs["username"] = username;
      this.inputs["password"] = password;
      this.attemptAutoSignIn(username, password);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
    this.errorHandler();
  }
  showComponent() {
    const {
      classes,
      otherComponent: OtherComponent,
      authData,
      externalTheme
    } = this.props;
    const {
      autoLogin,
      showLogin,
      showPassword,
      loading,
      error,
      canSignup,
      isRevrecUser,
      cbsso,
      loginInfo
    } = this.state;
    const {
      username,
      password
    } = this.inputs;
    const componentTheme = createMuiTheme(externalTheme);
    if (autoLogin || !showLogin) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(LinearProgress, null), loginInfo && /*#__PURE__*/React.createElement(Backdrop, {
        sx: {
          color: "#fff",
          zIndex: theme => theme.zIndex.drawer + 1
        },
        open: open
      }, /*#__PURE__*/React.createElement(Alert, {
        severity: "info"
      }, loginInfo), /*#__PURE__*/React.createElement(LinearProgress, null)));
    }
    if (!componentTheme) {
      return null;
    }
    const justSetPassword = authData && authData.justSetPassword || false;
    const disabled = !username || !password;
    const continueDisabled = !username;
    if (!showLogin) return null;
    return /*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: componentTheme
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.background, classes.parent)
    }, /*#__PURE__*/React.createElement(Fade, {
      in: showLogin,
      timeout: 500
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      className: classes.p0,
      spacing: 0,
      onKeyPress: e => this.onKeyDown(e)
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: logoImage,
      className: classes.logo,
      alt: "logo"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        paddingLeft: "10%",
        paddingRight: "10%"
      }
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card,
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes["signup-content"]
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.pt14
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h3",
      className: classes.headingMain
    }, "Log in"), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "body2",
      className: classes.main
    }, justSetPassword && !loginInfo ? "Please login with the new password you just set-up" : !loginInfo ? "Welcome Back! Please enter your details." : /*#__PURE__*/React.createElement(Alert, {
      severity: "warning"
    }, loginInfo))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      fullWidth: true,
      startIcon: /*#__PURE__*/React.createElement("img", {
        className: classes.googleLogo,
        src: "https://cdn.cdnlogo.com/logos/g/35/google-icon.svg"
      }),
      className: classes.google,
      onClick: this.googleSignIn
    }, "Login with Google")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 5,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Divider, {
      className: classes.divider
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.taCenter
    }, "OR")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 5,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Divider, {
      className: classes.divider
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.pl14
    }, error && /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: error.message || error
      }
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Email",
      variant: "outlined",
      fullWidth: true,
      value: username,
      name: "username",
      margin: "dense",
      key: "username",
      onChange: this.onInputChange
    })), isRevrecUser && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Password",
      variant: "outlined",
      fullWidth: true,
      margin: "dense",
      name: "password",
      key: "password",
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: this.handleClickShowPassword,
          onMouseDown: this.handleMouseDownPassword,
          edge: "end"
        }, showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
      },
      onChange: this.onInputChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.forgotPassword,
      color: "primary",
      variant: "body2",
      gutterBottom: true
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.cursorPointer,
      onClick: () => {
        this.changeState("forgotPassword");
        this.setState({
          editMode: false
        });
      }
    }, "Forgot Password")))), isRevrecUser && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      variant: "contained",
      color: "primary",
      disabled: loading || disabled,
      className: classes.button,
      onClick: () => this.signIn()
    }, "Log in")), !isRevrecUser && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      variant: "contained",
      color: "primary",
      id: "btn-continue",
      disabled: loading || continueDisabled,
      className: classes.button,
      onClick: () => this.checkUserIdp()
    }, "Continue")), this.state.showRegionSwitcher && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.regionSwitcher
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.taCenter
    }, "\uD83C\uDF0E You are on our", " ", this.state.currentRegion, " ", "data hosting centre. Switch to our", " ", /*#__PURE__*/React.createElement("span", {
      className: classes.regionLink,
      onClick: this.handleRegionSwitch
    }, this.state.currentRegion === "US" ? "EU" : "US"), " ", "data hosting centre.")), canSignup && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.signUp
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "Don't have an account?", " "), /*#__PURE__*/React.createElement(Typography, {
      color: "primary",
      className: `${classes.pl2} ${classes.cursorPointer} ${classes.forgotPassword}`,
      variant: "body2",
      gutterBottom: true,
      onClick: () => {
        this.errorHandler();
        this.changeState("signUp");
      }
    }, "Sign Up")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.signUp
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      gutterBottom: true,
      style: {
        paddingTop: 20,
        paddingBottom: 20
      }
    }, "By logging in you agree to accept our", /*#__PURE__*/React.createElement("a", {
      color: "primary",
      target: "_blank",
      href: "https://www.chargebee.com/company/terms"
    }, " ", "Terms of Service"), ".")), loading && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(LinearProgress, null))))), OtherComponent && /*#__PURE__*/React.createElement(OtherComponent, {
      self: this
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      lg: 6,
      className: classes.carousal
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.signinTopImage
    }, /*#__PURE__*/React.createElement("img", {
      src: signinTopImage$1
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Carousel, {
      autoPlay: "true",
      animation: "fade",
      interval: "5000"
    }, items$1.map((item, i) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.taCenter
    }, /*#__PURE__*/React.createElement("img", {
      height: "270",
      src: item.image
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.taCenter
    }, i == 0 && /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.textWhite
    }, "Comply with ASC 606. Eliminate", " ", /*#__PURE__*/React.createElement("br", null), " ", "Spreadsheets. Get Timely and ", /*#__PURE__*/React.createElement("br", null), " ", "Accurate Revenue Results."), i == 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.textWhite
    }, "Revenue Analytics"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.textWhite
    }, "Real-time reporting of Revenue across multiple levels,", " ", /*#__PURE__*/React.createElement("br", null), "dimensions and time periods. Analyze trends and explain changes", " ", /*#__PURE__*/React.createElement("br", null), "with precisions.")), i == 2 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.textWhite
    }, "Deferred Revenue"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.textWhite
    }, "Track detailed activities and balances, including", " ", /*#__PURE__*/React.createElement("br", null), "Long Term vs. Short Term Deferred Revenue for business scenarios", " ", /*#__PURE__*/React.createElement("br", null), "involving multi-currency, unbilled receivable asset, expense, multi-year contract,", /*#__PURE__*/React.createElement("br", null), "modification and variable consideration.")))))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.taLeft
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.bottomImg
    }, /*#__PURE__*/React.createElement("img", {
      src: signinBottomImage$1
    })))))))));
  }
}
var SignIn$1 = compose(withRouter, withCookies, withStyles(signInStyles, {
  withTheme: true
}))(SignIn);

const confirmSignInStyles = theme => ({
  ...globalStyles(theme)
});
class ConfirmSignIn extends AuthPiece {
  constructor(props) {
    super(props);
    this.errorHandler = error => {
      if (error) this.setState({
        error
      });else this.setState({
        error: undefined
      });
    };
    this.successHandler = success => {
      if (success) this.setState({
        success
      });else this.setState({
        success: undefined
      });
    };
    this.checkContact = async user => {
      try {
        const data = await Auth.verifiedContact(user);
        if (!JS.isEmpty(data.verified)) {
          this.changeState("signedIn", user);
        } else {
          user = Object.assign(user, data);
          this.changeState("verifyContact", user);
        }
      } catch (err) {
        this.errorHandler(err);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.confirm = async () => {
      const user = this.props.authData;
      const {
        code
      } = this.inputs;
      try {
        this.setState({
          loading: true,
          error: undefined
        });
        const mfaType = user.challengeName === "SOFTWARE_TOKEN_MFA" ? "SOFTWARE_TOKEN_MFA" : null;
        Auth.confirmSignIn(user, code, mfaType).then(() => {
          this.checkContact(user);
        }).catch(err => {
          if (err.message.localeCompare("Invalid code or auth state for the user.") === 0) {
            this.errorHandler({
              message: "Invalid code entered. Please enter the right code!"
            });
          } else {
            this.errorHandler(err);
          }
          this.setState({
            loading: false
          });
        });
      } catch (err) {
        this.errorHandler(err);
        this.setState({
          loading: false
        });
      }
    };
    this._validAuthStates = ["confirmSignIn"];
    this.state = {
      mfaType: "SMS",
      loading: false
    };
  }
  componentDidUpdate() {
    const user = this.props.authData;
    const mfaType = user && user.challengeName === "SOFTWARE_TOKEN_MFA" ? "TOTP" : "SMS";
    if (this.state.mfaType !== mfaType) this.setState({
      mfaType
    });
  }
  showComponent() {
    const {
      hide,
      classes,
      externalTheme
    } = this.props;
    const {
      loading,
      error,
      success
    } = this.state;
    if (hide && hide.includes(ConfirmSignIn)) {
      return null;
    }
    const componentTheme = createMuiTheme(externalTheme);
    return /*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: componentTheme
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      spacing: 0,
      justify: "center",
      alignItems: "center",
      className: classes.background
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      xs: 12
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes["signup-content"]
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: logoImage,
      className: classes.logo,
      alt: "logo"
    }), /*#__PURE__*/React.createElement(Box, {
      style: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://cdn.revrec.chargebee.com/sms.png",
      style: {
        width: 80
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      style: {
        marginLeft: 16,
        marginTop: 8
      },
      gutterBottom: true
    }, "MFA Authentication")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      gutterBottom: true,
      style: {
        paddingTop: 12
      }
    }, "Please enter the code you received through SMS for verification")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, error && error.message && /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, error.message)), success && success.message && /*#__PURE__*/React.createElement(Alert, {
      severity: "success"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, success.message))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Code",
      fullWidth: true,
      key: "code",
      name: "code",
      autoComplete: "off",
      onChange: this.handleInputChange
    })))), /*#__PURE__*/React.createElement(CardActions, {
      className: classes["lock-actions"]
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: loading,
      onClick: this.confirm,
      color: "primary",
      variant: "contained"
    }, "Confirm"), /*#__PURE__*/React.createElement(Button, {
      disabled: loading,
      onClick: () => this.changeState("signIn")
    }, "Back to Sign In")), loading && /*#__PURE__*/React.createElement(LinearProgress, null)))));
  }
}
var ConfirmSignIn$1 = compose(withStyles(confirmSignInStyles, {
  withTheme: true
}))(ConfirmSignIn);

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  tourFooter: {
    display: "flex",
    padding: "16px 20px"
  },
  signupLogo: {
    width: 16,
    padding: 9
  },
  divider: {
    marginTop: "5.6%"
  },
  p0: {
    padding: "0 !important"
  },
  taCenter: {
    textAlign: "center"
  }
});
const Transition = /*#__PURE__*/React.forwardRef(function Transistepstion(props, ref) {
  return /*#__PURE__*/React.createElement(Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});
const DialogTitle = withStyles(styles)(props => {
  const {
    children,
    classes,
    onClose,
    ...other
  } = props;
  return /*#__PURE__*/React.createElement(MuiDialogTitle, _extends({
    disableTypography: true,
    className: classes.root
  }, other), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, children), onClose ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null)) : null);
});
const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);
withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);
function WelcomePopup(props) {
  const {
    open,
    onClose,
    classes,
    username,
    googleSignup,
    cognitoSignup
  } = props;
  function handleSignup(func) {
    onClose && onClose();
    return func(true);
    //the true value tells the system to hide the google login option if you are signing in with email
  }
  return /*#__PURE__*/React.createElement(Dialog, {
    onClose: onClose,
    open: open,
    TransitionComponent: Transition,
    maxWidth: "md",
    disableEnforceFocus: true
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    onClose: onClose
  }), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.revrec.chargebee.com/quickview-welcome.svg"
  }))), /*#__PURE__*/React.createElement(Grid, {
    style: {
      minHeight: 440
    },
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Congratulations you have activated RecRec Quick View")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://www.chargebee.com/docs/revrec/about-revrec.html"
  }, "RevRec"), " ", "Quick View Reports replace RevenueStory and Classic Reports on Chargebee. They track revenue recognition results based on US GAAP (ASC 606) and IFRS 15.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://www.chargebee.com/docs/revrec/revrec-reporting.html"
  }, "Learn more"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, "To gain access to RevRec, you must first create an account. You MUST use the same email address you use for Chargebee, which is:"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement("br", null), username), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, "If you use Google to signin to Chargebee, click \"Signup with Google\" and use the account with the email address below. If not click signup with email.")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    fullWidth: true,
    startIcon: /*#__PURE__*/React.createElement("img", {
      className: classes.signupLogo,
      src: "https://cdn.cdnlogo.com/logos/g/35/google-icon.svg"
    }),
    className: classes.signup,
    onClick: () => handleSignup(googleSignup)
  }, "Sign Up with Google")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.p0
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5,
    className: classes.p0
  }, /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    className: classes.p0
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.taCenter
  }, "OR")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5,
    className: classes.p0
  }, /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    fullWidth: true,
    startIcon: /*#__PURE__*/React.createElement("img", {
      className: classes.signupLogo,
      src: "https://cdn.revrec.chargebee.com/images/chargebee-icon-orange.svg"
    }),
    className: classes.signup,
    onClick: () => handleSignup(cognitoSignup)
  }, "Sign Up with Email")))))));
}
var WelcomePopup$1 = compose(withStyles(styles))(WelcomePopup);

function has$1(value) {
  return value !== undefined && value !== null && value !== "";
}
const signUpStyles = theme => ({
  portalDashboardPageWrapper: {
    padding: "0px 20px 61px 27px",
    boxSizing: "border-box"
  },
  logo: {
    maxWidth: "200px"
  },
  headingMain: {
    fontSize: "28px",
    fontWeight: "900",
    marginBottom: "0",
    color: "#202022",
    marginLeft: "30px"
  },
  heading: {
    fontSize: "16px",
    fontWeight: "500",
    marginBottom: "0",
    color: "#676770"
  },
  subHeading: {
    fontSize: "13px",
    fontWeight: "400",
    marginBottom: "0px",
    marginTop: "5px",
    color: "#64648c",
    lineHeight: "18px"
  },
  nextBtn: {
    background: "#ff6a28",
    color: "#ffffff",
    fontSize: "15px",
    fontWeight: "500",
    textTransform: "uppercase",
    borderRadius: "5px",
    minWidth: "85px",
    marginBottom: "18px",
    marginTop: "10px",
    "&:hover": {
      background: "#ff6a28",
      color: "#ffffff"
    }
  },
  radioBtnLabel: {
    marginLeft: "5px",
    marginRight: "5px"
  },
  radio: {
    color: "#4e10a6",
    "& svg": {
      background: "#4e10a6",
      width: "11px",
      height: "11px",
      borderRadius: "20px"
    },
    "&:hover": {
      color: "#4e10a6",
      background: "#dbc0ff!important",
      "& svg": {
        fill: "#4e10a6"
      }
    },
    "&$checked": {
      color: "#4e10a6",
      background: "#dbc0ff",
      width: "8px",
      height: "8px"
    }
  },
  checked: {},
  signUpForm: {
    maxWidth: "370px"
  },
  list: {
    marginLeft: "0px"
  },
  listItemRoot: {
    padding: "0px",
    margin: "0px",
    display: "revert",
    listStyle: "none",
    color: "#64648c"
  },
  listItemRootText: {
    fontSize: "13px",
    fontWeight: "400",
    marginBottom: "0px"
  },
  listItemText: {
    fontWeight: "400",
    color: "#64648c",
    fontSize: "13.5px"
  },
  checkIcon: {
    color: green[500],
    marginRight: "2px",
    "& svg": {
      position: "relative",
      top: "3px",
      left: "2px",
      width: "18px",
      height: "18px"
    }
  },
  circleicon: {
    "& svg": {
      position: "relative",
      top: "-1px",
      left: "6px",
      width: "7px",
      height: "7px",
      fill: "#64648c",
      marginRight: "11px"
    }
  },
  crossIcon: {
    color: red[500],
    marginRight: "2px",
    "& svg": {
      position: "relative",
      top: "3px",
      left: "2px",
      width: "18px",
      height: "18px"
    }
  },
  radiobtn: {
    marginLeft: "25px",
    marginTop: "10px"
  },
  signupwidth: {
    marginLeft: "25px"
  },
  input: {
    marginBottom: "10px"
  },
  minheading: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#64648c",
    marginLeft: "0px"
  },
  alert: {
    marginBottom: theme.spacing(3)
  },
  error: {
    fontSize: "12px",
    color: "#de3618"
  },
  parent: {
    display: "flex",
    justifyContent: "space-around",
    position: "relative",
    flex: 1,
    "& .MuiCardActions-root": {
      paddingLeft: "22px",
      paddingRight: "22px"
    }
  },
  signUpWidget: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: 0,
    padding: "16px 8px"
  },
  actions: {
    justifyContent: "space-between"
  },
  signup: {
    // backgroundColor: '#4285F4',
    fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif;'
  },
  signupLogoBox: {
    width: theme.spacing(3)
  },
  signupLogo: {
    width: 16,
    padding: 9
  },
  signupBox: {
    paddingLeft: "0.1px",
    // backgroundColor: '#4285F4',
    display: "flex",
    justifyContent: "center",
    border: "1px solid grey"
  },
  loginDivider: {
    height: 1,
    margin: theme.spacing(1),
    background: "#dcdce1",
    display: "block",
    textAlign: "center",
    position: "relative"
  },
  loginDividerText: {
    top: "-10px",
    backgroundColor: "white",
    padding: "0 6px",
    display: "inline-block"
  },
  pt14: {
    paddingTop: "14px !important"
  },
  divider: {
    marginTop: "5.6%"
  },
  p0: {
    padding: "0 !important"
  },
  pl2: {
    paddingLeft: 2
  },
  taCenter: {
    textAlign: "center"
  },
  main: {
    paddingTop: 16
    // color:'#818195'
  },
  forgotPassword: {
    textAlign: "end"
  },
  button: {
    minHeight: "42px"
  },
  signUp: {
    display: "flex",
    justifyContent: "center",
    color: "#818195"
  },
  cursorPointer: {
    cursor: "pointer",
    color: "#2d6a8a"
  },
  carousal: {
    backgroundColor: "#012a38"
  },
  signinTopImage: {
    textAlign: "right",
    maxHeight: "200px"
  },
  taLeft: {
    textAlign: "left"
  },
  textWhite: {
    color: "white"
  },
  bottomImg: {
    position: "absolute",
    bottom: "8px",
    left: "50%"
  },
  ...globalStyles(theme)
});
const signinBottomImage = "https://cdn.revrec.chargebee.com/images/signup/linePatternBottom.svg";
const signinTopImage = "https://cdn.revrec.chargebee.com/images/signup/linePatternTop.svg";
var items = [{
  image: "https://cdn.revrec.chargebee.com/images/signup/singin1.svg"
}, {
  image: "https://cdn.revrec.chargebee.com/images/signup/signin2.svg"
}, {
  image: "https://cdn.revrec.chargebee.com/images/signup/signin3.svg"
}];
class SignUp extends AuthPiece {
  constructor(props) {
    super(props);

    // figureout if user opened sso for signup process
    this.signUp = async () => {
      const {
        username,
        password,
        name,
        passwordValidation,
        cbsso
      } = this.state;
      this.clearValidationError();
      let hasErrors = false;
      let nameRegex = /^([\w]{2,})+\s+([\w\s]{2,})+$/i;
      if (!has$1(name)) {
        const error = {
          code: "MISSING_VALUE",
          message: "Full name cannot be empty."
        };
        this.errorHandler("nameError", error);
        hasErrors = true;
      }
      if (!nameRegex.test(name)) {
        const error = {
          code: "INVALID_NAME",
          message: "We need your full name."
        };
        this.errorHandler("nameError", error);
        hasErrors = true;
      }
      if (!has$1(username) || !Utils.isEmail(username)) {
        const error = {
          code: "INVALID_EMAIL",
          message: "We need a valid email address"
        };
        this.errorHandler("usernameError", error);
        hasErrors = true;
      }
      if (!password || !password.length || !Object.keys(passwordValidation).every(key => passwordValidation[key] === true)) {
        const error = {
          code: "PASSWORD_NON_CONFORMING",
          message: "Your password is missing or does not meet criteria"
        };
        this.errorHandler("passwordError", error);
        hasErrors = true;
      }
      if (hasErrors) return;
      const nameParts = name.split(/\s/);
      let given_name, family_name;
      if (nameParts.length === 1) given_name = nameParts[0];
      if (nameParts.length === 2) {
        given_name = nameParts[0];
        family_name = nameParts[1] || "";
      }
      if (nameParts.length > 2) {
        given_name = nameParts[0];
        family_name = nameParts[nameParts.length - 1];
      }
      this.errorHandler();
      //clear errors..

      try {
        this.setState({
          loading: true
        });
        const {
          user
        } = await Auth.signUp({
          username,
          password,
          attributes: {
            email: username,
            // optional
            family_name,
            given_name
          }
        });

        // verify incoming user
        if (cbsso && user && user.username === username) {
          // Raise the Event of New User to keycloak broker
          await API.registerNewUserToKeycloak({
            username,
            email: username,
            family_name,
            given_name
          });
        }
        this.changeState("confirmSignUp", username);
      } catch (e) {
        this.errorHandler("error", {
          code: "CREATE_ERROR",
          message: e.toString()
        });
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.handlePasswordFieldTouched = () => {
      this.setState({
        isPasswordFieldTouched: true
      });
    };
    this.googleSignIn = () => {
      const {
        config
      } = this.props;
      const {
        oauth
      } = config.AWS;
      const {
        userPoolWebClientId
      } = config.AWS.Auth;
      let url = `https://${oauth.domain}/oauth2/authorize?identity_provider=Google&redirect_uri=${oauth.redirectSignIn}&response_type=CODE&client_id=${userPoolWebClientId}&scope=aws.cognito.signin.user.admin email openid phone profile`;
      window.location.href = url;
    };
    this.handlePasswordChange = e => {
      let passwordValidation = {
        oneLetter: false,
        minimumChars: false,
        oneNumber: false,
        oneSpecialChar: false
      };
      this.setState({
        passwordChange: e.target.value,
        password: e.target.value,
        passwordValidation,
        isPasswordFieldTouched: true
      });
      this.handleInputChange(e);
      const password = e.target.value;

      // at least 8 characters
      if (!(password.length < 10)) {
        passwordValidation.minimumChars = true;
      }

      // at least one letter
      if (!(password.search(/[a-z]/i) < 0)) {
        passwordValidation.oneLetter = true;
      }

      //  at least one number
      if (!(password.search(/[0-9]/) < 0)) {
        passwordValidation.oneNumber = true;
      }

      //  at least one Special Char
      if (/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)) {
        passwordValidation.oneSpecialChar = true;
      }
      this.setState({
        passwordValidation
      });
    };
    this.handleClickShowPassword = event => {
      const {
        showPassword
      } = this.state;
      this.setState({
        showPassword: !showPassword
      });
    };
    this.handleMouseDownPassword = event => {
      event.preventDefault();
    };
    this.handleEmail = e => {
      var _Utils$normalizeEmail;
      const val = (_Utils$normalizeEmail = Utils.normalizeEmail(e.target.value)) != null ? _Utils$normalizeEmail : "";
      this.setState({
        [e.target.name]: val
      });
      this.handleInputChange(e);
    };
    this.handleChange = e => {
      this.setState({
        [e.target.name]: e.target.value
      });
      this.handleInputChange(e);
    };
    this.closeWelcomePopup = () => {
      this.setState({
        openWelcomePopup: false
      });
    };
    const params = window.location.search && queryString.parse(window.location.search) || {};
    const _cbsso = params.cbsso && params.cbsso === "true" || window.location.origin.match(/-sso.revrec/) && window.location.origin.match(/-sso.revrec/).length > 0;
    this._validAuthStates = ["signUp"];
    this.errorHandler = this.errorHandler.bind(this);
    this.closeWelcomePopup = this.closeWelcomePopup.bind(this);
    this.onEmailSignUp = this.onEmailSignUp.bind(this);
    this.state = {
      loading: false,
      passwordValidation: {
        minimumChars: false,
        oneLetter: false,
        oneSpecialChar: false,
        oneNumber: false
      },
      password: "",
      isPasswordFieldTouched: false,
      isNameValid: true,
      openWelcomePopup: false,
      emailSignUp: false,
      hideGoogle: false,
      cbsso: _cbsso
    };
  }
  componentDidMount() {
    const params = queryString.parse(window.location.search);
    const {
      cre
    } = params;
    const {
      history
    } = this.props;
    if (cre) {
      console.error("!!!CRE BLOCK PROCESSING (SIGNUP)!!!");
      try {
        const data = atob(cre);
        const o = JSON.parse(data);
        if (o && o.login && o.signUp) {
          const openWelcomePopup = (o == null ? void 0 : o.license) === "rev-essential";
          this.setState({
            username: o.login,
            name: `${o.firstName} ${o.lastName}`,
            license: o.license,
            openWelcomePopup
          });
          history.replace({
            search: ""
          });
        }
      } catch (e) {
        console.log("Failed to read cre block", e);
      }
    }
  }
  errorHandler(name, error) {
    if (error) {
      this.setState({
        [name]: error,
        loading: false
      });
    } else {
      this.setState({
        error
      });
    }
  }
  clearValidationError() {
    this.setState({
      nameError: undefined,
      passwordError: undefined,
      usernameError: undefined
    });
  }
  onEmailSignUp(hideGoogle = false) {
    this.setState({
      emailSignUp: true,
      hideGoogle
    });
  }
  showComponent(theme) {
    const {
      hide,
      classes,
      externalTheme
    } = this.props;
    const {
      username,
      name,
      showPassword,
      nameError,
      usernameError,
      passwordError,
      error,
      loading,
      passwordValidation,
      license,
      openWelcomePopup,
      emailSignUp,
      hideGoogle
    } = this.state;
    const componentTheme = createMuiTheme(externalTheme);
    if (!externalTheme) {
      return null;
    }
    if (hide && hide.includes(SignUp)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: componentTheme
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.background, classes.parent)
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      className: classes.p0,
      spacing: 0
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: logoImage,
      className: classes.logo,
      alt: "logo"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        paddingLeft: "10%",
        paddingRight: "10%"
      }
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card,
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes["signup-content"]
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.pt14
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h3"
    }, "Sign Up"), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "body2",
      className: classes.main
    }, "Please enter your details to create an account")), !hideGoogle && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      fullWidth: true,
      startIcon: /*#__PURE__*/React.createElement("img", {
        className: classes.signupLogo,
        src: "https://cdn.cdnlogo.com/logos/g/35/google-icon.svg"
      }),
      className: classes.signup,
      onClick: this.googleSignIn
    }, "Sign Up with Google")), !hideGoogle && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 5,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Divider, {
      className: classes.divider
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.taCenter
    }, "OR")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 5,
      className: classes.p0
    }, /*#__PURE__*/React.createElement(Divider, {
      className: classes.divider
    })))), emailSignUp || /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      fullWidth: true,
      startIcon: /*#__PURE__*/React.createElement("img", {
        className: classes.signupLogo,
        src: "https://cdn.revrec.chargebee.com/images/chargebee-icon-orange.svg"
      }),
      className: classes.signup,
      onClick: this.onEmailSignUp
    }, "Sign Up with Email")), emailSignUp && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.pl14
    }, error && /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, error.message || error))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Name",
      id: "name",
      value: name,
      variant: "outlined",
      placeholder: "Enter your full name",
      name: "name",
      className: classes.input,
      key: "name",
      fullWidth: true,
      margin: "dense",
      onChange: this.handleChange
    }), nameError && /*#__PURE__*/React.createElement(Typography, {
      variant: "span",
      className: classes.error
    }, nameError.message), this.state.isNameValid ? null : /*#__PURE__*/React.createElement(Typography, {
      variant: "span",
      className: classes.error
    }, "We need a full Name")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Email",
      id: "email",
      variant: "outlined",
      value: username,
      placeholder: "Enter your email",
      fullWidth: true,
      className: classes.input,
      margin: "dense",
      key: "username",
      name: "username",
      onChange: this.handleEmail,
      disabled: license === "rev-essential"
    }), usernameError && /*#__PURE__*/React.createElement(Typography, {
      variant: "span",
      className: classes.error
    }, usernameError.message)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Password",
      id: "password",
      variant: "outlined",
      placeholder: "Enter your password",
      fullWidth: true,
      margin: "dense",
      key: "password",
      name: "password",
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: this.handleClickShowPassword,
          onMouseDown: this.handleMouseDownPassword,
          edge: "end"
        }, showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
      },
      onChange: this.handlePasswordChange
    }), passwordError && /*#__PURE__*/React.createElement(Typography, {
      variant: "span",
      className: classes.error
    }, passwordError.message)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.minheading
    }, "Minimum requirements"), /*#__PURE__*/React.createElement(List, {
      className: classes.list
    }, /*#__PURE__*/React.createElement(ListItem, {
      className: classes.listItemRoot
    }, /*#__PURE__*/React.createElement(ListItemText, {
      className: classes.listItemRootText
    }, /*#__PURE__*/React.createElement("span", null, this.state.isPasswordFieldTouched ? /*#__PURE__*/React.createElement(React.Fragment, null, passwordValidation.minimumChars ? /*#__PURE__*/React.createElement("span", {
      className: classes.checkIcon
    }, " ", /*#__PURE__*/React.createElement(Check, null), " ") : /*#__PURE__*/React.createElement("span", {
      className: classes.crossIcon
    }, " ", /*#__PURE__*/React.createElement(Close, null), " ")) : /*#__PURE__*/React.createElement("span", {
      className: classes.circleicon
    }, /*#__PURE__*/React.createElement(FiberManualRecord, null)), /*#__PURE__*/React.createElement("span", {
      className: classes.listItemText
    }, "10 characters")))), /*#__PURE__*/React.createElement(ListItem, {
      className: classes.listItemRoot
    }, /*#__PURE__*/React.createElement(ListItemText, {
      className: classes.listItemRootText
    }, " ", /*#__PURE__*/React.createElement("span", null, this.state.isPasswordFieldTouched ? /*#__PURE__*/React.createElement(React.Fragment, null, passwordValidation.oneLetter ? /*#__PURE__*/React.createElement("span", {
      className: classes.checkIcon
    }, " ", /*#__PURE__*/React.createElement(Check, null), " ") : /*#__PURE__*/React.createElement("span", {
      className: classes.crossIcon
    }, " ", /*#__PURE__*/React.createElement(Close, null), " ")) : /*#__PURE__*/React.createElement("span", {
      className: classes.circleicon
    }, /*#__PURE__*/React.createElement(FiberManualRecord, null)), /*#__PURE__*/React.createElement("span", {
      className: classes.listItemText
    }, "1 Letter")))), /*#__PURE__*/React.createElement(ListItem, {
      className: classes.listItemRoot
    }, /*#__PURE__*/React.createElement(ListItemText, {
      className: classes.listItemRootText
    }, /*#__PURE__*/React.createElement("span", null, this.state.isPasswordFieldTouched ? /*#__PURE__*/React.createElement(React.Fragment, null, passwordValidation.oneSpecialChar ? /*#__PURE__*/React.createElement("span", {
      className: classes.checkIcon
    }, " ", /*#__PURE__*/React.createElement(Check, null), " ") : /*#__PURE__*/React.createElement("span", {
      className: classes.crossIcon
    }, " ", /*#__PURE__*/React.createElement(Close, null), " ")) : /*#__PURE__*/React.createElement("span", {
      className: classes.circleicon
    }, /*#__PURE__*/React.createElement(FiberManualRecord, null)), /*#__PURE__*/React.createElement("span", {
      className: classes.listItemText
    }, "1 Special Character")))), /*#__PURE__*/React.createElement(ListItem, {
      className: classes.listItemRoot
    }, /*#__PURE__*/React.createElement(ListItemText, {
      className: classes.listItemRootText
    }, /*#__PURE__*/React.createElement("span", null, this.state.isPasswordFieldTouched ? /*#__PURE__*/React.createElement(React.Fragment, null, passwordValidation.oneNumber ? /*#__PURE__*/React.createElement("span", {
      className: classes.checkIcon
    }, " ", /*#__PURE__*/React.createElement(Check, null), " ") : /*#__PURE__*/React.createElement("span", {
      className: classes.crossIcon
    }, " ", /*#__PURE__*/React.createElement(Close, null), " ")) : /*#__PURE__*/React.createElement("span", {
      className: classes.circleicon
    }, /*#__PURE__*/React.createElement(FiberManualRecord, null)), /*#__PURE__*/React.createElement("span", {
      className: classes.listItemText
    }, "1 Number")))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      id: "cognito-signup",
      fullWidth: true,
      variant: "contained",
      color: "primary",
      disabled: loading,
      className: classes.button,
      onClick: () => this.signUp()
    }, "Sign up")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.signUp
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "Already have an account?", " "), /*#__PURE__*/React.createElement(Typography, {
      color: "primary",
      className: `${classes.pl2} ${classes.cursorPointer}`,
      variant: "body2",
      gutterBottom: true,
      onClick: () => {
        this.changeState("signIn");
      }
    }, "Log in")), loading && /*#__PURE__*/React.createElement(LinearProgress, null))))))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      lg: 6,
      className: classes.carousal
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.signinTopImage
    }, /*#__PURE__*/React.createElement("img", {
      src: signinTopImage
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Carousel, {
      autoPlay: "true",
      animation: "fade",
      interval: "5000"
    }, items.map((item, i) => /*#__PURE__*/React.createElement("div", {
      key: i
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.taCenter
    }, /*#__PURE__*/React.createElement("img", {
      height: "270",
      src: item.image
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.taCenter
    }, i == 0 && /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.textWhite
    }, "Comply with ASC 606. Eliminate", " ", /*#__PURE__*/React.createElement("br", null), " ", "Spreadsheets. Get Timely and", " ", /*#__PURE__*/React.createElement("br", null), " Accurate Revenue Results."), i == 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.textWhite
    }, "Revenue Analytics"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.textWhite
    }, "Real-time reporting of Revenue across multiple levels,", " ", /*#__PURE__*/React.createElement("br", null), "dimensions and time periods. Analyze trends and explain changes", " ", /*#__PURE__*/React.createElement("br", null), "with precisions.")), i == 2 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.textWhite
    }, "Deferred Revenue"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.textWhite
    }, "Track detailed activities and balances, including", " ", /*#__PURE__*/React.createElement("br", null), "Long Term vs. Short Term Deferred Revenue for business scenarios", " ", /*#__PURE__*/React.createElement("br", null), "involving multi-currency, unbilled receivable asset, expense, multi-year contract,", /*#__PURE__*/React.createElement("br", null), "modification and variable consideration.")))))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.taLeft
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.bottomImg
    }, /*#__PURE__*/React.createElement("img", {
      src: signinBottomImage
    }))))))), /*#__PURE__*/React.createElement(WelcomePopup$1, {
      open: openWelcomePopup,
      onClose: this.closeWelcomePopup,
      googleSignup: this.googleSignIn,
      cognitoSignup: this.onEmailSignUp,
      username: username
    }));
  }
}
var SignUp$1 = compose(withStyles(signUpStyles, {
  withTheme: true
}), withRouter)(SignUp);

function A(props) {
  const {
    href,
    children
  } = props;
  return /*#__PURE__*/React.createElement("a", {
    style: {
      textDecoration: 'underline',
      textDecorationColor: 'blue'
    },
    onClick: () => Utils.showPopup({
      url: href
    })
  }, children);
}

function showAlert(props) {
  return swal(props);
}

const emailImg = "https://cdn.revrec.chargebee.com/images/signup/verifyEmail.svg";
const confirmSignUpStyles = theme => ({
  link: {
    color: theme.palette.primary.main,
    fontSize: "13px"
  },
  portalDashboardPageWrapper: {
    padding: "0px 20px 61px 27px",
    boxSizing: "border-box"
  },
  headingMain: {
    fontSize: "28px",
    fontWeight: "900",
    marginBottom: "0",
    color: "#202022",
    marginLeft: "20px"
  },
  radioBtn: {
    marginLeft: "15px",
    marginTop: "15px",
    marginBottom: "10px"
  },
  inputlabel: {
    fontSize: "15px",
    fontWeight: "500",
    marginBottom: "0",
    color: "#202022",
    lineHeight: "19px"
  },
  getcodebox: {
    marginBottom: "18px"
  },
  getcode: {
    fontSize: "15px",
    fontWeight: "500",
    color: "#202022"
  },
  signupWidth: {
    marginLeft: "22px"
  },
  alert: {
    marginLeft: "14px"
  },
  signUpForm: {
    marginLeft: "15px"
  },
  taCenter: {
    textAlign: "center"
  },
  cursorPointer: {
    cursor: "pointer"
  },
  pt4: {
    paddinTop: "4%"
  },
  backToLoginDiv: {
    justifyContent: "center",
    display: "flex",
    padding: "3%"
  },
  pt10: {
    paddingTop: "10% !important"
  },
  pl7: {
    paddingLeft: "7% !important"
  },
  pl2: {
    paddingLeft: 2
  },
  resendCode: {
    display: "flex",
    justifyContent: "center",
    color: "#818195"
  },
  otpInput: {
    width: "4rem !important",
    height: "4rem",
    margin: "0 1rem",
    fontSize: "2rem",
    borderRadius: "4px",
    border: "1px solid rgba(0, 0, 0, 0.3)"
  },
  ...globalStyles(theme)
});
class ConfirmSignUp extends AuthPiece {
  constructor(props) {
    super(props);

    // figureout if user opened sso for signup process
    this.handleChange = value => {
      const event = {
        target: {
          name: "code",
          value: value
        }
      };
      this.handleInputChange(event);
      this.setState({
        code: value
      });
    };
    this.confirm = async () => {
      const username = this.usernameFromAuthData() || this.inputs.username;
      const {
        code
      } = this.inputs;
      const {
        cbsso
      } = this.state;
      this.errorHandler();
      try {
        this.setState({
          loading: true
        });
        const response = await Auth.confirmSignUp(username, code);

        // verify incoming user
        if (cbsso && response === "SUCCESS") {
          // Raise the Event of New User to keycloak broker linked
          // with 'unassigned' business entity, the reason is to
          // let this user logIn to RevRec so it can choose a domain
          await API.confirmNewUserToKeycloak({
            username,
            email: username,
            linkDefaultBE: true
          });
        }
        await showAlert({
          title: "Success",
          text: `Your account was successfully confirmed! Please login.`,
          buttons: [false, "Continue"],
          icon: "success",
          timer: 2000
        });
        this.changeState("signedUp");
      } catch (err) {
        this.errorHandler(err);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.resend = async () => {
      const username = this.usernameFromAuthData() || this.inputs.username;
      this.errorHandler();
      try {
        this.setState({
          loading: true
        });
        await Auth.resendSignUp(username);
        showAlert({
          title: `Resent Code`,
          icon: "success",
          text: `We resent a code to your email address`,
          timer: 3000,
          buttons: false
        });
      } catch (err) {
        this.errorHandler(err);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    const params = window.location.search && queryString.parse(window.location.search) || {};
    const _cbsso = params.cbsso && params.cbsso === "true" || window.location.origin.match(/-sso.revrec/) && window.location.origin.match(/-sso.revrec/).length > 0;
    this._validAuthStates = ["confirmSignUp"];
    this.confirm = this.confirm.bind(this);
    this.resend = this.resend.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.state = {
      loading: false,
      codeResent: true,
      cbsso: _cbsso
    };
  }
  errorHandler(error) {
    if (error) this.setState({
      error
    });else this.setState({
      error: undefined
    });
  }
  showComponent(theme) {
    const {
      hide,
      classes,
      externalTheme
    } = this.props;
    const {
      loading,
      error,
      code
    } = this.state;
    const username = this.usernameFromAuthData() || this.inputs.username;
    if (hide && hide.includes(ConfirmSignUp)) {
      return null;
    }
    const componentTheme = createMuiTheme(externalTheme);
    return /*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: componentTheme
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      spacing: 0
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: logoImage,
      className: classes.logo,
      alt: "logo"
    })), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 0,
      direction: "column",
      alignItems: "center",
      justify: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card,
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes["signup-content"]
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      spacing: 1,
      className: classes.taCenter
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: emailImg
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, " ", "Verify your email")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "body1",
      className: classes.main
    }, "We sent a verification code to", " ", username)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, error && /*#__PURE__*/React.createElement(Alert, {
      className: classes.alert,
      severity: "error"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, error.message || error))), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(OtpInput, {
      name: "code",
      value: code,
      onChange: this.handleChange,
      numInputs: 6,
      key: "code",
      separator: /*#__PURE__*/React.createElement("span", null, "-"),
      inputStyle: classes.otpInput,
      isInputNum: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.pt10
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: loading,
      onClick: this.confirm,
      color: "primary",
      variant: "contained",
      fullWidth: true
    }, "Verify code")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.resendCode
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "Didn't receive an email?", " "), /*#__PURE__*/React.createElement(Typography, {
      color: "primary",
      className: `${classes.pl2} ${classes.cursorPointer}`,
      variant: "body2",
      gutterBottom: true,
      onClick: this.resend
    }, "Click to resend")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.backToLoginDiv
    }, /*#__PURE__*/React.createElement(ArrowBack, null), /*#__PURE__*/React.createElement(Typography, {
      className: classes.cursorPointer,
      variant: "body2",
      gutterBottom: true,
      style: {
        paddingTop: 2
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.cursorPointer,
      onClick: () => {
        this.changeState("signIn");
        this.errorHandler();
      }
    }, " ", "Back to log in"))), loading && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(LinearProgress, null)))))))));
  }
}
var ConfirmSignUp$1 = compose(withStyles(confirmSignUpStyles, {
  withTheme: true
}))(ConfirmSignUp);

const verifyContactStyles = theme => ({
  contactPanel: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    position: "relative",
    flex: 1
  },
  link: {
    color: theme.palette.primary.main
  },
  ...globalStyles(theme)
});
const logger$1 = new Logger("VerifyContact");
class VerifyContact extends AuthPiece {
  constructor(props) {
    super(props);
    this.requestCode = async () => {
      try {
        const attributeToVerify = "email";
        this.setState({
          loading: true
        });
        this.errorHandler();
        await Auth.verifyCurrentUserAttribute(attributeToVerify);
        showAlert({
          title: `Code Sent`,
          icon: "success",
          text: `We sent a code to your email address`,
          timer: 3000,
          buttons: false
        });
        this.setState({
          verifyAttr: attributeToVerify
        });
      } catch (err) {
        this.errorHandler(err);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.submit = async () => {
      const attr = this.state.verifyAttr;
      const {
        code
      } = this.inputs;
      this.errorHandler();
      try {
        this.setState({
          loading: true
        });
        await Auth.verifyCurrentUserAttributeSubmit(attr, code);
        this.changeState("signedIn", this.props.authData);
        this.setState({
          verifyAttr: null
        });
      } catch (err) {
        this.errorHandler(err);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this._validAuthStates = ["verifyContact"];
    this.state = {
      verifyAttr: null,
      loading: false
    };
  }
  verifyView() {
    const user = this.props.authData;
    if (!user) {
      logger$1.debug("no user for verify");
      return null;
    }
    const {
      unverified
    } = user;
    if (!unverified) {
      logger$1.debug("no unverified on user");
      return null;
    }
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justify: "flex-start",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "We will do this by sending you a code to your email and asking you to provide it back to us.")));
  }
  submitView() {
    return /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Code",
      fullWidth: true,
      key: "code",
      name: "code",
      autoComplete: "off",
      onChange: this.handleInputChange
    });
  }
  errorHandler(error) {
    if (error) this.setState({
      error
    });else this.setState({
      error: undefined
    });
  }
  showComponent(theme) {
    const {
      hide,
      classes,
      externalTheme
    } = this.props;
    const {
      loading,
      error
    } = this.state;
    if (hide && hide.includes(VerifyContact)) {
      return null;
    }
    const componentTheme = createMuiTheme(externalTheme);
    return /*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: componentTheme
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.contactPanel, classes.background)
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justify: "center",
      direction: "row",
      spacing: 0,
      alignItems: "center",
      className: classes.background
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 9
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes["signup-content"]
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: logoImage,
      className: classes.logo,
      alt: "logo"
    }), /*#__PURE__*/React.createElement(Box, {
      style: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://cdn.revrec.chargebee.com/shield.png",
      style: {
        width: 80
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      component: "h2",
      style: {
        marginLeft: 16,
        marginTop: 8
      },
      gutterBottom: true
    }, "Account Security")), /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      gutterBottom: true
    }, /*#__PURE__*/React.createElement("br", null), "To ensure that everything stays nice and secure we need to verify your account email. We need this to ensure we can process account related data (such as password change requests).", /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, error && error.message && /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, error.message))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 12,
      xs: 12
    }, this.state.verifyAttr ? this.submitView() : this.verifyView()))), /*#__PURE__*/React.createElement(CardActions, {
      className: classes["lock-actions"]
    }, this.renderButtons(), /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      disabled: loading,
      onClick: () => {
        this.changeState("signIn");
        this.errorHandler();
      }
    }, "Back to login")), this.state.verifyAttr && /*#__PURE__*/React.createElement(Box, {
      paddingTop: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "Didn't get a code?"), /*#__PURE__*/React.createElement("a", {
      onClick: this.requestCode
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.link
    }, "Request another one"))), loading && /*#__PURE__*/React.createElement(LinearProgress, null))))))));
  }
  renderButtons() {
    const {
      loading
    } = this.state;
    if (this.state.verifyAttr) return /*#__PURE__*/React.createElement(Button, {
      disabled: loading,
      onClick: this.submit,
      color: "primary",
      variant: "contained"
    }, "Verify");else return /*#__PURE__*/React.createElement(Button, {
      disabled: loading,
      onClick: this.requestCode,
      color: "primary",
      variant: "contained"
    }, "Get Code");
  }
}
var VerifyContact$1 = compose(withStyles(verifyContactStyles, {
  withTheme: true
}))(VerifyContact);

function errorMessage(msg) {
  if (/UsernameExistsException: An account with the given email already*/i.test(msg)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Yipee! you already have an account! ", /*#__PURE__*/React.createElement("br", null), "Please sign in instead or recover your password.");
  }
  if (/The email address does not exist in the system./i.test(msg)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "If this was a valid email you will receive a code to reset your password.");
  }
  return msg;
}

const forgotPasswordStyles = theme => ({
  actions: {
    justifyContent: "space-between",
    paddingLeft: "18px",
    paddingRight: "18px"
  },
  link: {
    color: theme.palette.primary.main
  },
  taCenter: {
    textAlign: "center"
  },
  cursorPointer: {
    cursor: "pointer",
    color: "#2d6a8a"
  },
  pt4: {
    paddinTop: "4%"
  },
  backToLoginDiv: {
    justifyContent: "center",
    display: "flex",
    padding: "3%"
  },
  pt10: {
    paddingTop: "10% !important"
  },
  pl7: {
    paddingLeft: "7% !important"
  },
  taLeft: {
    textAlign: "left"
  },
  ...globalStyles(theme)
});
const keyImage = "https://cdn.revrec.chargebee.com/images/signup/key_new.svg";
class ForgotPassword extends AuthPiece {
  constructor(props) {
    super(props);
    this.userExists = async username => {
      try {
        await Auth.signUp(username, "123");
      } catch (error) {
        const code = error.code;
        switch (code) {
          case "UsernameExistsException":
            return true;
          default:
            return false;
        }
      }
    };
    this.requestCode = async () => {
      const {
        username
      } = this.inputs;
      if (Utils.isBlank(username)) {
        const error = {
          code: "INVALID_EMAIL",
          message: "The email address cannot be empty."
        };
        this.errorHandler(error);
        return;
      }
      if (!Utils.isEmail(username)) {
        const error = {
          code: "INVALID_EMAIL",
          message: "The email address is invalid."
        };
        this.errorHandler(error);
        return;
      }
      const userExists = await this.userExists(username);
      this.errorHandler();
      try {
        this.setState({
          loading: true
        });
        if (userExists) {
          await Auth.forgotPassword(username, {});
        }
        swal({
          title: `Sent a Code`,
          icon: "success",
          text: `We sent a code to your email. Use it to set your password`,
          timer: 3000,
          buttons: false
        });
        this.setState({
          delivery: true
        });
      } catch (err) {
        this.errorHandler(err);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.submit = async () => {
      const {
        username,
        code,
        password,
        cpassword
      } = this.inputs;
      if (password !== cpassword) {
        this.errorHandler({
          message: "Password and Confirm Password do not match"
        });
        return;
      }
      this.errorHandler();
      try {
        this.setState({
          loading: true
        });
        await Auth.forgotPasswordSubmit(username, code, password);
        this.setState({
          delivery: null
        });
        this.changeState("signIn", {
          resetErrors: true,
          justSetPassword: true,
          username,
          password
        });
      } catch (err) {
        this.errorHandler(err);
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.handleClickShowPassword = () => {
      const {
        showPassword
      } = this.state;
      this.setState({
        showPassword: !showPassword
      });
    };
    this.handleMouseDownPassword = event => {
      event.preventDefault();
    };
    this.handleEmailChange = event => {
      this.handleInputChange(event);
      this.setState({
        [event.target.name]: event.target.value
      });
    };
    this.handlePasswordChange = e => {
      this.handleInputChange(e);
      this.setState({
        [e.target.name]: e.target.value
      });
    };
    this._validAuthStates = ["forgotPassword"];
    this.state = {
      delivery: null,
      loading: false
    };
    this.errorHandler = this.errorHandler.bind(this);
  }
  componentDidUpdate() {
    const {
      authData
    } = this.props;
    const isForcedReset = authData && authData.adminReset || false;
    if (isForcedReset && this.inputs && !this.inputs["username"]) {
      const username = authData.username;
      if (username) {
        this.inputs["username"] = username;
      }
    }
  }
  showRequestCode() {
    const {
      authData
    } = this.props;
    const {
      username
    } = this.inputs;
    const isForcedReset = authData && authData.adminReset || false;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isForcedReset && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "error",
      gutterBottom: true
    }, "For security reasons your password was reset. You need to set a new password for your account.")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Email Address",
      fullWidth: true,
      placeholder: "Enter your email",
      value: username,
      name: "username",
      key: "username",
      onChange: this.handleEmailChange
    })));
  }
  errorHandler(error) {
    if (error) {
      this.setState({
        error
      });
    } else {
      this.setState({
        error: undefined
      });
    }
  }
  showNewPassword() {
    const {
      classes
    } = this.props;
    const {
      showPassword
    } = this.state;
    const {
      password,
      cpassword,
      username
    } = this.inputs;
    const passwordsNoMatch = cpassword ? password != cpassword : false;
    return /*#__PURE__*/React.createElement(React.Fragment, null, username && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "Resetting password for the account ", username)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Code from email",
      fullWidth: true,
      margin: "normal",
      name: "code",
      key: "code",
      onChange: this.handlePasswordChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "New Password",
      fullWidth: true,
      margin: "normal",
      key: "password",
      name: "password",
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: this.handleClickShowPassword,
          onMouseDown: this.handleMouseDownPassword,
          edge: "end"
        }, showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
      },
      onChange: this.handlePasswordChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Confirm Password",
      fullWidth: true,
      margin: "normal",
      key: "cpassword",
      name: "cpassword",
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: this.handleClickShowPassword,
          onMouseDown: this.handleMouseDownPassword,
          edge: "end"
        }, showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
      },
      onChange: e => {
        this.handlePasswordChange(e);
        this.setState({
          confirmChange: this.state.confirmChange ? "true" : "false"
        });
      }
    })), passwordsNoMatch && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.taLeft
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.error
    }, "Password and confirmations do not match")));
  }
  showComponent() {
    const {
      hide,
      classes,
      externalTheme
    } = this.props;
    const {
      loading,
      error
    } = this.state;
    const {
      username,
      password,
      cpassword
    } = this.inputs;
    const disabled = this.state.delivery ? !password || !cpassword || cpassword !== password : false;
    if (hide && hide.includes(ForgotPassword)) {
      return null;
    }
    const [handler, label] = this.state.delivery ? [this.submit, "Reset Password"] : [this.requestCode, "Send Code"];
    const componentTheme = createMuiTheme(externalTheme);
    return /*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: componentTheme
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      spacing: 0,
      onKeyPress: e => {
        if (e.key === "Enter") handler();
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: logoImage,
      className: classes.logo,
      alt: "logo"
    })), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.pt4
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 2,
      lg: 4
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      justify: "center",
      alignItems: "center",
      xs: 12,
      md: 8,
      lg: 4
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card,
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes["signup-content"]
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      spacing: 1,
      className: classes.taCenter
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: keyImage
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, !this.state.delivery ? /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.headingMain
    }, " ", "Forgot Password") : /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: classes.headingMain
    }, " ", "Set new password")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, !this.state.delivery ? /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "body1",
      className: classes.main
    }, "No worries, we'll send you resend instructions.") : /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "body1",
      className: classes.main
    }, "Your new password must be different from ", /*#__PURE__*/React.createElement("br", null), " ", "previously used passwords.")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, error && error.message && /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, errorMessage(error.message)))), !this.state.delivery ? this.showRequestCode() : this.showNewPassword(), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.pt10
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: disabled || loading,
      onClick: handler,
      color: "primary",
      variant: "contained",
      fullWidth: true
    }, label)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.backToLoginDiv
    }, /*#__PURE__*/React.createElement(ArrowBack, null), /*#__PURE__*/React.createElement(Typography, {
      className: classes.cursorPointer,
      variant: "body2",
      gutterBottom: true,
      style: {
        paddingTop: 2
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.cursorPointer,
      onClick: () => {
        this.setState({
          delivery: null
        });
        this.changeState("signIn");
        this.errorHandler();
      }
    }, " ", "Back to log in"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, this.state.delivery && /*#__PURE__*/React.createElement(Box, {
      paddingTop: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      className: classes.pl7
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "Didn't get a code?"), /*#__PURE__*/React.createElement("a", {
      onClick: this.requestCode
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.link
    }, "Request another one")))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      paddingTop: 2,
      display: "flex",
      flexDirection: "row"
    }, "*If you used federated login like google to sign up you can't get your password here"))))), loading && /*#__PURE__*/React.createElement(LinearProgress, null))))));
  }
}
var ForgotPassword$1 = compose(withStyles(forgotPasswordStyles, {
  withTheme: true
}))(ForgotPassword);

const logger = new Logger("RequireNewPassword");
const requirePasswordStyles = theme => ({
  ...globalStyles(theme)
});
class RequireNewPassword extends AuthPiece {
  constructor(props) {
    super(props);
    this.checkContact = async user => {
      try {
        this.setState({
          loading: true
        });
        const verifyResponse = await Auth.verifiedContact(user);
        if (!JS.isEmpty(verifyResponse.verified)) {
          this.changeState("signedIn", user);
        } else {
          user = Object.assign(user, verifyResponse);
          this.changeState("verifyContact", user);
        }
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.change = async () => {
      const userData = this.props.authData;
      const {
        password,
        cpassword
      } = this.inputs;
      this.errorHandler();
      if (password == cpassword) {
        try {
          this.setState({
            loading: true
          });
          const user = await Auth.completeNewPassword(userData, password);
          if (user.challengeName === "SMS_MFA") {
            this.changeState("confirmSignIn", user);
          } else if (user.challengeName === "MFA_SETUP") {
            logger.debug("TOTP setup", user.challengeParam);
            this.changeState("TOTPSetup", user);
          } else {
            await this.checkContact(user);
          }
        } catch (err) {
          this.errorHandler(err);
        } finally {
          this.setState({
            loading: false
          });
        }
      } else {
        this.errorHandler({
          error: {
            code: "PASSWORD_NOT_SAME",
            message: "New passwords do not match."
          }
        });
      }
    };
    this.handlePasswordChange = e => {
      this.setState({
        passwordChange: e.target.value
      });
      this.handleInputChange(e);
    };
    this.handleClickShowPassword = event => {
      const {
        showPassword
      } = this.state;
      this.setState({
        showPassword: !showPassword
      });
    };
    this.handleMouseDownPassword = event => {
      event.preventDefault();
    };
    this._validAuthStates = ["requireNewPassword"];
    this.errorHandler = this.errorHandler.bind(this);
    this.state = {
      loading: false
    };
  }
  errorHandler(error) {
    if (error) this.setState({
      error
    });else this.setState({
      error: undefined
    });
  }
  showComponent(theme) {
    const {
      hide,
      classes,
      externalTheme
    } = this.props;
    if (hide && hide.includes(RequireNewPassword)) {
      return null;
    }
    const {
      loading,
      error,
      showPassword
    } = this.state;
    const {
      password,
      cpassword
    } = this.inputs;
    const passwordsNoMatch = cpassword ? password != cpassword : false;
    const disabled = !(cpassword && password && cpassword == password);
    const componentTheme = createMuiTheme(externalTheme);
    return /*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: componentTheme
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      spacing: 0,
      justify: "center",
      alignItems: "center",
      className: classes.background
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 6,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 9
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes["signup-content"]
    }, /*#__PURE__*/React.createElement(Grid, {
      direction: "column",
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: logoImage,
      className: classes.logo,
      alt: "logo"
    }), /*#__PURE__*/React.createElement(Box, {
      style: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://cdn.revrec.chargebee.com/shield.png",
      style: {
        width: 80
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      component: "h2",
      style: {
        marginLeft: 16,
        marginTop: 8
      },
      gutterBottom: true
    }, "Account Security / Password")), /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      gutterBottom: true
    }, /*#__PURE__*/React.createElement("br", null), "Please enter a new password that will replace the temporary one that was assigned to your account", /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, error && error.message && /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, error.message))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 12,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "New Password",
      fullWidth: true,
      margin: "normal",
      name: "password",
      key: "password",
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: this.handleClickShowPassword,
          onMouseDown: this.handleMouseDownPassword,
          edge: "end"
        }, showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
      },
      onChange: this.handlePasswordChange
    }), /*#__PURE__*/React.createElement(TextField, {
      label: "Confirm Password",
      fullWidth: true,
      margin: "normal",
      name: "cpassword",
      key: "cpassword",
      type: showPassword ? "text" : "password",
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: this.handleClickShowPassword,
          onMouseDown: this.handleMouseDownPassword,
          edge: "end"
        }, showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
      },
      onChange: this.handlePasswordChange
    })), passwordsNoMatch && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "Passwords do not match")))), /*#__PURE__*/React.createElement(CardActions, {
      className: classes["lock-actions"]
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      disabled: loading,
      onClick: () => this.changeState("signIn")
    }, "Back to login"), /*#__PURE__*/React.createElement(Button, {
      disabled: loading || disabled,
      onClick: this.change,
      color: "primary",
      variant: "contained"
    }, "Change")), loading && /*#__PURE__*/React.createElement(LinearProgress, null)))))));
  }
}
var RequireNewPassword$1 = compose(withStyles(requirePasswordStyles, {
  withTheme: true
}))(RequireNewPassword);

const isString = value => {
  return typeof value === "string" || value instanceof String;
};
const isEmpty = value => {
  return isNil(value) || isString(value) && value.length === 0;
};
function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: `simple-tabpanel-${index}`,
    "aria-labelledby": `simple-tab-${index}`
  }, other), value === index && /*#__PURE__*/React.createElement(SwipeableViews, null, /*#__PURE__*/React.createElement(Box, {
    p: 3
  }, /*#__PURE__*/React.createElement(Typography, null, children))));
}
function formatPhoneNumber(phoneNumberString) {
  var phoneno = /^\+(?:[0-9] ?){10,14}[0-9]$/;
  if (phoneno.test(phoneNumberString)) {
    return phoneNumberString;
  } else {
    return null;
  }
}
function shadeColor(color, percent) {
  const f = parseInt(color.slice(1), 16);
  const t = percent < 0 ? 0 : 255;
  const p = percent < 0 ? percent * -1 : percent;
  const R = f >> 16;
  const G = f >> 8 & 0x00ff;
  const B = f & 0x0000ff;
  return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1); // eslint-disable-line
}
const profileStyles = theme => ({
  portalContactDetailsHeader: {
    height: 160,
    background: shadeColor(theme.palette.primary.main, 0.22),
    "&:before": {
      background: shadeColor(theme.palette.primary.main, 0.12)
    },
    "&:after": {
      background: theme.palette.primary.main
    }
  },
  ["portal-contact-title"]: {
    bottom: -98,
    display: "flex",
    position: "relative",
    alignItems: "center",
    marginBottom: 10,
    justifyContent: "flex-start",
    marginLeft: "auto"
  },
  portalContactDetailsSocialIcons: {
    color: theme.palette.secondary.main,
    padding: "0px 10px"
  },
  portalContactDetailsAvatarContainer: {
    position: "relative",
    textAlign: "center",
    marginTop: -90
  },
  portalContactDetailsAvatar: {
    width: 160,
    display: "inline-block"
  },
  portalContactDetailsAvatarImg: {
    borderRadius: "50%",
    borderWidth: 16,
    borderStyle: "solid",
    position: "relative",
    zIndex: 3,
    width: "100%",
    boxSizing: "border-box",
    borderColor: theme.palette.background.default
  },
  portalContactDetailsExtra: {
    minWidth: 160,
    zIndex: 5,
    position: "relative",
    textAlign: "center"
  },
  portalContactDetailsExtraP: {
    marginBottom: 0,
    marginTop: 0,
    lineHeight: "24px"
  },
  icon: {
    color: "#fff",
    cursor: "pointer",
    "&:hover": {
      color: "#000"
    }
  },
  paper: {
    position: "absolute",
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  button: {
    // margin: theme.spacing(1),
  },
  alert: {
    width: "100%",
    maxWidth: 500,
    padding: "10px"
  },
  buttonRoot: {
    display: "flex",
    alignItems: "center"
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    color: lightBlue[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1)
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(2)
    }
  },
  logo: {
    height: 90,
    marginBottom: 10,
    [theme.breakpoints.down("md")]: {
      height: 60
    }
  },
  cardContent: {
    textAlign: "center"
  },
  closeButton: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main
    }
  },
  girdContainer: {
    background: "white",
    borderRadius: 8
  },
  root: {
    padding: 0,
    maxWidth: "125pc"
  }
});
class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = (event, tabIndex) => {
      const {
        onChange
      } = this.props;
      this.setState({
        tabIndex
      }, () => onChange && onChange(tabIndex));
    };
    this.handleMFAChange = async event => {
      const isChecked = event.target.checked;
      const {
        currentUser
      } = this.state;
      const mfaType = isChecked ? "SMS" : "NOMFA";
      const updatedUser = Object.assign({}, currentUser);
      updatedUser.preferredMFA = mfaType;
      this.setState({
        currentUser: updatedUser
      });
    };
    this.handlePhone = value => {
      const {
        currentUser
      } = this.state;
      // replace All not supported into old version browsers
      const inputPhone = value && value.replace(/\s+|\(|\)|\-/g, "");
      currentUser.attributes["phone_number"] = inputPhone;
      this.setState({
        currentUser: Object.assign({}, currentUser)
      });
    };
    this.handleInputChange = event => {
      const {
        currentUser
      } = this.state;
      const attribute = event.target;
      if (attribute) {
        currentUser.attributes[attribute.name] = attribute.value;
        this.setState({
          currentUser: Object.assign({}, currentUser)
        });
      }
    };
    this.handleOrgAttribute = event => {
      const attribute = event.target;
      const {
        currentOrganization
      } = this.state;
      if (attribute) {
        currentOrganization[attribute.name] = attribute.value;
        this.setState({
          currentOrganization: Object.assign({}, currentOrganization)
        });
      }
    };
    this.handleCodeInputChange = event => {
      const attribute = event.target;
      if (attribute) {
        this.setState({
          code: attribute.value
        });
      }
    };
    this.handleClose = () => {
      const {
        currentUser
      } = this.state;
      this.setState({
        open: false,
        loading: false
      });
      const mfaType = "NOMFA";
      const updatedUser = Object.assign({}, currentUser);
      updatedUser.preferredMFA = mfaType;
      this.setState({
        currentUser: updatedUser
      });
    };
    this.handlePasswordInputChange = event => {
      let {
        passwordInputs
      } = this.state;
      const element = event.target;
      if (element) {
        passwordInputs[element.name] = element.value;
        this.setState({
          passwordInputs
        });
      }
    };
    this.updateUser = async () => {
      const {
        currentUser,
        currentOrganization,
        originalOrganization,
        originalUser
      } = this.state;
      const {
        patchOrganization,
        patchUser
      } = this.props;
      this.setState({
        loading: true
      });
      const attributeUpdates = currentUser.attributes;
      if (attributeUpdates) {
        try {
          const cognitoUser = await Auth.currentAuthenticatedUser();
          const phoneNumber = attributeUpdates["phone_number"] || "";
          attributeUpdates["phone_number"] = phoneNumber != "" ? formatPhoneNumber(phoneNumber) : phoneNumber;
          const attrUpdate = Object.assign({}, attributeUpdates);
          delete attrUpdate["sub"];
          delete attrUpdate["custom:super-admin"];
          delete attrUpdate["custom:auth"];
          delete attrUpdate["custom:data"];
          delete attrUpdate["custom:impersonate"];
          delete attrUpdate["custom:partner-max"];
          if ((originalUser.preferredMFA === "NOMFA" || originalUser.preferredMFA === "SMS_MFA") && currentUser.preferredMFA === "SMS") {
            if (originalUser.attributes["phone_number"] !== attributeUpdates["phone_number"]) {
              await Auth.updateUserAttributes(cognitoUser, attrUpdate);
            }
            Auth.verifyUserAttribute(cognitoUser, "phone_number").then(() => {
              this.setState({
                open: true
              });
            }).catch(err => {
              this.errorHandler(err, "basics");
            });
          } else {
            await Auth.updateUserAttributes(cognitoUser, attrUpdate);
            await Auth.setPreferredMFA(cognitoUser, currentUser.preferredMFA === "SMS_MFA" ? "SMS" : "NOMFA");
            patchUser(currentUser);
            this.successHandler({
              message: "Profile has been updated"
            }, "basics");
            if (originalOrganization.merchantId !== currentOrganization.merchantId || originalOrganization.address !== currentOrganization.address) {
              const updatedOrg = cloneDeep(originalOrganization);
              updatedOrg.merchantId = currentOrganization.merchantId;
              updatedOrg.address = currentOrganization.address;
              await updateOrganization(null, updatedOrg);
              patchOrganization(updatedOrg);
            }
          }
        } catch (err) {
          this.errorHandler(err, "basics");
        } finally {
          this.setState({
            editMode: false,
            loading: false
          });
        }
      }
    };
    this.changePassword = async () => {
      const {
        passwordInputs
      } = this.state;
      this.setState({
        errors: {},
        success: {},
        loading: true
      });
      this.state;
      if (isEmpty(passwordInputs.oldPassword) || isEmpty(passwordInputs.new_password) || isEmpty(passwordInputs.confirm_password)) return this.errorHandler({
        message: "All feild are required!"
      }, "password");
      if (passwordInputs.new_password != passwordInputs.oldPassword) {
        if (passwordInputs.new_password == passwordInputs.confirm_password) {
          const user = await Auth.currentAuthenticatedUser();
          Auth.changePassword(user, passwordInputs.oldPassword, passwordInputs.new_password).then(data => {
            this.setState({
              passwordInputs: {},
              editMode: false,
              loading: false
            });
            this.successHandler({
              message: "Password has been changed successfully"
            }, "password");
            this.currentPassordInputRef.value = "";
            this.newPasswordInputsRef.value = "";
            this.confirmNewPasswordInputsRef.value = "";
            Auth.signOut({
              global: true
            });
          }).catch(err => {
            if (err.code === "NotAuthorizedException") {
              this.errorHandler({
                message: "Incorrect current password!"
              }, "password");
            } else {
              this.errorHandler(err, "password");
            }
          });
        } else {
          this.errorHandler({
            message: "New password does not match with confirm new password!"
          }, "password");
        }
      } else {
        this.errorHandler({
          message: "New password must be different from current password!"
        }, "password");
      }
    };
    this.handleCancel = () => {
      this.currentPassordInputRef.value = "";
      this.newPasswordInputsRef.value = "";
      this.confirmNewPasswordInputsRef.value = "";
      this.setState({
        editMode: false,
        editPasswordMode: false,
        errors: {},
        success: {},
        passwordInputs: {}
      });
    };
    this.editPasswordChange = () => {
      const {
        editPasswordMode
      } = this.state;
      this.setState({
        editPasswordMode: !editPasswordMode,
        errors: {},
        success: {}
      });
    };
    this.verify = async () => {
      const {
        currentUser,
        currentOrganization,
        originalOrganization,
        originalUser,
        code
      } = this.state;
      const {
        patchOrganization,
        patchUser
      } = this.props;
      this.setState({
        verifyAttr: true,
        errors: {},
        success: {}
      });
      const attributeUpdates = currentUser.attributes;
      if (attributeUpdates) {
        try {
          const cognitoUser = await Auth.currentAuthenticatedUser();
          Auth.verifyUserAttributeSubmit(cognitoUser, "phone_number", code).then(async () => {
            await Auth.setPreferredMFA(cognitoUser, currentUser.preferredMFA);
            patchUser(currentUser);
            this.successHandler({
              message: "Phone number has been verified and setup MFA"
            }, "basics");
            this.setState({
              editMode: false,
              verifyAttr: false,
              open: false
            });
            if (originalOrganization.merchantId !== currentOrganization.merchantId || originalOrganization.address !== currentOrganization.address) {
              const updatedOrg = cloneDeep(originalOrganization);
              updatedOrg.merchantId = currentOrganization.merchantId;
              updatedOrg.address = currentOrganization.address;
              await updateOrganization(null, updatedOrg);
              patchOrganization(updatedOrg);
            }
          }).catch(err => {
            this.errorHandler({
              message: err.message
            }, "code");
            this.setState({
              verifyAttr: false
            });
          });
        } catch (err) {
          this.errorHandler(err, "code");
          this.setState({
            editMode: false,
            verifyAttr: false
          });
        }
      }
    };
    this.resend = async () => {
      this.setState({
        errors: {},
        success: {}
      });
      const cognitoUser = await Auth.currentAuthenticatedUser();
      Auth.verifyUserAttribute(cognitoUser, "phone_number").then(() => {
        this.successHandler({
          message: "Code has been sent to your phone number"
        }, "code");
      }).catch(err => {
        this.errorHandler({
          message: err.message
        }, "code");
      });
    };
    this.state = {
      authState: props.authState,
      currentUser: props.authData,
      editMode: false,
      editPasswordMode: false,
      passwordInputs: {},
      errors: {},
      success: {},
      loading: false,
      profileImg: null,
      profileImgFile: undefined,
      open: false,
      code: "",
      verifyAttr: false,
      tabIndex: 0
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.getImage = this.getImage.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCodeInputChange = this.handleCodeInputChange.bind(this);
    this.verify = this.verify.bind(this);
    this.resend = this.resend.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.editChange = this.editChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  loadState(nextProps) {
    const {
      currentUser,
      currentOrganization
    } = nextProps;
    const stateUpdate = {
      authState: "signedIn"
    };
    if (currentUser) {
      stateUpdate.currentUser = cloneDeep(currentUser);
      stateUpdate.originalUser = currentUser;
    }
    if (currentOrganization) {
      stateUpdate.currentOrganization = cloneDeep(currentOrganization);
      stateUpdate.originalOrganization = currentOrganization;
    }
    this.setState(stateUpdate);
  }
  componentDidMount() {
    this.loadState(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.currentUser !== nextProps.currentUser || this.props.currentOrganization !== nextProps.currentOrganization) this.loadState(nextProps);
  }
  errorHandler(err, type) {
    let {
      errors
    } = this.state;
    this.setState({
      loading: false
    });
    if (err) {
      errors[type] = err;
      this.setState({
        errors
      });
    }
  }
  successHandler(msg, type) {
    let {
      success
    } = this.state;
    this.setState({
      loading: false
    });
    if (msg) {
      success[type] = msg;
      this.setState({
        success
      });
    }
  }
  getImage(event) {
    const files = event && event.target && event.target.files;
    if (files) {
      let reader = new FileReader();
      reader.onload = e => {
        this.setState({
          profileImg: e.target.result,
          profileImgFile: files[0]
        });
      };
      reader.readAsDataURL(files[0]);
    }
  }
  editChange() {
    const {
      editMode
    } = this.state;
    this.setState({
      editMode: !editMode,
      errors: {},
      success: {}
    });
  }
  render() {
    const {
      currentUser,
      currentOrganization,
      editMode,
      editPasswordMode
    } = this.state;
    if (!currentUser || !currentUser.attributes || !currentOrganization) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderEditPanel(), this.renderVerifyContactNumberModal());
  }
  renderVerifyContactNumberModal() {
    const {
      open
    } = this.state;
    const {
      classes
    } = this.props;
    return /*#__PURE__*/React.createElement(Dialog, {
      open: open,
      onClose: this.handleClose
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Close the dialog"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: this.handleClose
    }, /*#__PURE__*/React.createElement(Close, {
      className: classes.closeButton,
      fontSize: "medium",
      style: {
        flexDirection: "row-reverse"
      }
    })))), /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 0,
      direction: "column"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://cdn.revrec.chargebee.com/sms.png",
      style: {
        width: 40
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      style: {
        marginLeft: 16,
        marginTop: 8
      },
      gutterBottom: true
    }, "MFA Authentication")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      gutterBottom: true,
      style: {
        paddingTop: 12
      }
    }, "Please enter the code you received through SMS for verification")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, this.errorView("code"), this.successView("code")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Code",
      fullWidth: true,
      key: "code",
      name: "code",
      autoComplete: "off",
      onChange: this.handleCodeInputChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, this.renderButtons())))));
  }
  renderButtons() {
    const {
      classes
    } = this.props;
    const {
      verifyAttr,
      editMode
    } = this.state;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        marginTop: 15
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.buttonRoot
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: verifyAttr,
      onClick: this.verify,
      color: "primary",
      variant: "contained"
    }, "Verify Code"), verifyAttr && /*#__PURE__*/React.createElement(CircularProgress, {
      size: 24,
      className: classes.buttonProgress
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: verifyAttr,
      className: classes.button,
      onClick: this.resend,
      color: "inherit",
      variant: "contained"
    }, "Resend Code"))));
  }
  renderEditPanel() {
    const {
      currentUser,
      tabIndex
    } = this.state;
    const userAttributes = currentUser && currentUser.attributes;
    const isGoogleAuthenticated = currentUser && currentUser.username.startsWith("google_");
    const {
      loading,
      editMode,
      editPasswordMode,
      currentOrganization
    } = this.state;
    const {
      classes
    } = this.props;
    const isDisabled = isGoogleAuthenticated || !editMode;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement(Container, {
      style: {
        maxWidth: "120pc"
      }
    }, /*#__PURE__*/React.createElement(Box, {
      paddingY: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 0,
      justify: "flex-start"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      className: classes.girdContainer
    }, /*#__PURE__*/React.createElement(Tabs, {
      value: tabIndex,
      onChange: this.handleChange,
      indicatorColor: "primary",
      textColor: "primary"
    }, /*#__PURE__*/React.createElement(Tab, {
      label: "General"
    }), !isGoogleAuthenticated && /*#__PURE__*/React.createElement(Tab, {
      label: "Change Password"
    })), /*#__PURE__*/React.createElement(TabPanel, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      value: tabIndex,
      index: 0
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      item: true,
      xs: 12,
      spacing: 2
    }, this.errorView("basics"), this.successView("basics"), isGoogleAuthenticated && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://logo.clearbit.com/google.com",
      style: {
        width: 30,
        paddingRight: 16
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      color: "textSecondary"
    }, "You are logged in with your google account. ", /*#__PURE__*/React.createElement("br", null), "Please manage your credentials directly on", " ", /*#__PURE__*/React.createElement("a", {
      href: "https://myaccount.google.com/"
    }, "google"), "."))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      spacing: 9,
      xs: 12
    }, /*#__PURE__*/React.createElement(IconButton, {
      id: "enableEdit",
      name: "Enable Edit",
      size: "normal",
      variant: "outlined",
      color: "gray",
      onClick: this.editChange
    }, editMode ? /*#__PURE__*/React.createElement(Tooltip, {
      title: "Lock Profile"
    }, /*#__PURE__*/React.createElement(LockOpen, {
      fontSize: "small"
    })) : /*#__PURE__*/React.createElement(Tooltip, {
      title: "Unlock to Edit Profile"
    }, /*#__PURE__*/React.createElement(Lock, {
      fontSize: "small"
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "First Name",
      disabled: isDisabled,
      fullWidth: true,
      margin: "normal",
      name: "given_name",
      key: "given_name",
      variant: "outlined",
      value: userAttributes.given_name,
      onChange: this.handleInputChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      disabled: isDisabled,
      label: "Last Name",
      fullWidth: true,
      margin: "normal",
      name: "family_name",
      key: "family_name",
      variant: "outlined",
      value: userAttributes.family_name,
      onChange: this.handleInputChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Email Address",
      fullWidth: true,
      margin: "normal",
      key: "username",
      name: "username",
      variant: "outlined",
      value: userAttributes.email,
      disabled: true,
      onChange: () => {}
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      value: userAttributes.phone_number,
      disabled: isDisabled,
      label: "Phone Number",
      key: "phone_number",
      name: "phone_number",
      variant: "outlined",
      style: {
        width: "100%",
        marginTop: 15
      },
      defaultCountry: "us",
      onChange: this.handlePhone
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Company Domain",
      disabled: true,
      fullWidth: true,
      margin: "normal",
      name: "domain",
      key: "domain",
      variant: "outlined",
      value: currentOrganization.domain || "",
      onChange: this.handleOrgAttribute
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Company Address",
      disabled: isDisabled,
      fullWidth: true,
      margin: "normal",
      name: "address",
      key: "address",
      variant: "outlined",
      value: currentOrganization.address || "",
      onChange: this.handleOrgAttribute
    })), !isGoogleAuthenticated && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "MFA can only be enabled once phone number has been provided."
    }, /*#__PURE__*/React.createElement(FormControl, {
      disabled: !userAttributes.phone_number || !editMode,
      helperText: "Uses your phone for SMS based Multi-Factor Authentication"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Enable MFA"), /*#__PURE__*/React.createElement(Switch, {
      color: "primary",
      disabled: !userAttributes.phone_number || !editMode,
      checked: currentUser.preferredMFA !== "NOMFA",
      onChange: this.handleMFAChange,
      inputProps: {
        "aria-label": "secondary checkbox"
      }
    }), /*#__PURE__*/React.createElement(FormHelperText, null, "SMS based Multi-Factor Authentication.", " "))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        marginTop: 15
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.buttonRoot
    }, /*#__PURE__*/React.createElement(Box, {
      mr: 1
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      variant: "contained",
      color: "primary",
      disabled: loading || !editMode,
      className: classes.button,
      onClick: this.updateUser
    }, "Update"), loading && /*#__PURE__*/React.createElement(CircularProgress, {
      size: 24,
      className: classes.buttonProgress
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        error: {},
        success: {},
        editMode: false,
        currentUser: this.props.currentUser,
        currentOrganization: this.props.currentOrganization
      }),
      disabled: !editMode,
      color: "inherit",
      variant: "contained"
    }, "Cancel")))))), /*#__PURE__*/React.createElement(TabPanel, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      value: tabIndex,
      index: 1
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 9,
      lg: 9
    }, this.errorView("password"), this.successView("password"), /*#__PURE__*/React.createElement(IconButton, {
      id: "enableEdit",
      name: "Enable Edit",
      size: "normal",
      variant: "outlined",
      color: "gray",
      onClick: this.editPasswordChange
    }, editPasswordMode ? /*#__PURE__*/React.createElement(Tooltip, {
      title: "Lock Profile"
    }, /*#__PURE__*/React.createElement(LockOpen, {
      fontSize: "small"
    })) : /*#__PURE__*/React.createElement(Tooltip, {
      title: "Unlock to Edit Profile"
    }, /*#__PURE__*/React.createElement(Lock, {
      fontSize: "small"
    }))), /*#__PURE__*/React.createElement(TextField, {
      label: "Current Password",
      disabled: !editPasswordMode,
      fullWidth: true,
      placeholder: "Enter your current password",
      margin: "normal",
      type: "password",
      name: "oldPassword",
      key: "oldPassword",
      variant: "outlined",
      inputRef: el => this.currentPassordInputRef = el,
      onChange: this.handlePasswordInputChange
    }), /*#__PURE__*/React.createElement(TextField, {
      label: "New Password",
      disabled: !editPasswordMode,
      fullWidth: true,
      placeholder: "Enter your new password",
      margin: "normal",
      type: "password",
      name: "new_password",
      key: "new_password",
      variant: "outlined",
      inputRef: el => this.newPasswordInputsRef = el,
      onChange: this.handlePasswordInputChange
    }), /*#__PURE__*/React.createElement(TextField, {
      label: "Confirm New Password",
      disabled: !editPasswordMode,
      fullWidth: true,
      placeholder: "Please confirm new password",
      margin: "normal",
      type: "password",
      name: "confirm_password",
      key: "confirm_password",
      variant: "outlined",
      inputRef: el => this.confirmNewPasswordInputsRef = el,
      onChange: this.handlePasswordInputChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        marginTop: 15
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.buttonRoot
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: !editPasswordMode,
      type: "submit",
      variant: "contained",
      color: "primary",
      style: {
        color: "white",
        marginRight: 8
      },
      disabled: loading || !editPasswordMode,
      className: classes.button,
      onClick: this.changePassword
    }, "Change Password"), loading && /*#__PURE__*/React.createElement(CircularProgress, {
      size: 24,
      className: classes.buttonProgress
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: !editPasswordMode,
      onClick: this.handleCancel,
      color: "inherit",
      variant: "contained"
    }, "Cancel")))))))))));
  }
  errorView(type) {
    const {
      classes
    } = this.props;
    const {
      errors
    } = this.state;
    if (!errors || errors && !errors[type]) return;
    const error = errors[type];
    return /*#__PURE__*/React.createElement("div", {
      className: classes.alert
    }, /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, error.message)));
  }
  successView(type) {
    const {
      classes
    } = this.props;
    const {
      success
    } = this.state;
    if (!success || success && !success[type]) return;
    const success_msg = success[type];
    return /*#__PURE__*/React.createElement("div", {
      className: classes.alert
    }, /*#__PURE__*/React.createElement(Alert, {
      severity: "success"
    }, /*#__PURE__*/React.createElement(AlertTitle, null, success_msg.message)));
  }
}
var Profile$1 = compose(withWidth(), withStyles(profileStyles, {
  withTheme: true
}))(Profile);

const useInvitationStyles = makeStyles(theme => ({
  title: {
    color: "black"
  },
  header: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: "400 !important",
    borderBottom: "1px solid rgba(224, 224, 224, 1)"
  },
  infoAnnotation: {
    padding: theme.spacing(1),
    margin: theme.spacing(1)
  },
  paper: {
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: 10000
  },
  chip: {
    // height: 25,
    marginRight: `${theme.spacing(1) / 2}px`,
    marginBottom: `${theme.spacing(1) / 2}px`
  },
  chipFocused: {
    backgroundColor: emphasize(theme.palette.type === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
  },
  input: {
    display: "flex",
    minWidth: 120,
    height: "auto",
    padding: "0.5938em"
  },
  inputMulti: {
    display: "flex",
    minWidth: 120,
    height: "auto",
    padding: "0.5938em"
  },
  inputContainer: {
    display: "flex",
    flexDirection: "row"
  }
}));
function inputComponent({
  inputRef,
  ...props
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: inputRef
  }, props));
}
function Control(props) {
  const textFieldProps = props.selectProps.textFieldProps;
  const {
    isMulti
  } = props.selectProps;
  return /*#__PURE__*/React.createElement("div", {
    className: props.selectProps.classes.inputContainer
  }, /*#__PURE__*/React.createElement(TextField, _extends({
    fullWidth: true,
    variant: "outlined",
    InputProps: {
      inputComponent,
      inputProps: {
        className: isMulti ? props.selectProps.classes.inputMulti : props.selectProps.classes.input,
        inputRef: textFieldProps.inputRef,
        children: props.children,
        ...props.innerProps
      }
    }
  }, textFieldProps)), /*#__PURE__*/React.createElement(A, {
    href: "https://www.chargebee.com/docs/revrec/user-management.html#roles-and-permissions",
    className: props.selectProps.classes.infoAnnotation
  }, /*#__PURE__*/React.createElement(Info, {
    color: "disabled"
  })));
}
function MultiValue(props) {
  return /*#__PURE__*/React.createElement(Chip, {
    tabIndex: -1,
    label: props.children,
    className: classNames(props.selectProps.classes.chip, {
      [props.selectProps.classes.chipFocused]: props.isFocused
    }),
    onDelete: props.removeProps.onClick,
    deleteIcon: /*#__PURE__*/React.createElement(Close, _extends({
      fontSize: "small"
    }, props.removeProps))
  });
}
function Menu(props) {
  let popoverNode = props.selectProps.popoverNode.current;
  let width = popoverNode && popoverNode.offsetWidth || -1;
  if (props.options && props.options.length > 0) {
    let longest = Math.max(...props.options.map(el => {
      if (el.label) {
        return el.label.length < el.value.length ? el.value.length : el.label.length;
      } else {
        return el.length;
      }
    }));
    const newWidth = 8 * longest + 100;
    width = newWidth > width ? newWidth : width;
  }
  return /*#__PURE__*/React.createElement(Popper, _extends({
    open: true,
    style: {
      width
    },
    anchorEl: popoverNode,
    className: props.selectProps.classes.paper
  }, props.innerProps), /*#__PURE__*/React.createElement(Paper, {
    square: true
  }, props.children));
}
let components = {
  Menu,
  MultiValue,
  Control
};
function InvitationForm(props) {
  const {
    onClose,
    onSave,
    open,
    requireComment = false,
    orgConfig
  } = props;
  const [email, setEmail] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [newRoles, setNewRoles] = React.useState([]);
  const [shrinkLabel, setShrinkLabel] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const [emailHelp, setEmailHelp] = React.useState("Work email address");
  const classes = useInvitationStyles();
  const disabled = !firstName || !lastName || !email || !newRoles || !newRoles.length || !Utils.isEmail(email) || requireComment && !comment.trim();
  async function onInvite() {
    try {
      setLoading(true);
      const roles = [];
      newRoles.map(role => roles.push(role.value));
      await onSave({
        email,
        firstName,
        lastName,
        roles,
        clientId: props.clientId,
        comment
      });
    } finally {
      setLoading(false);
      onClose();
      setEmail("");
      setFirstName("");
      setLastName("");
      setNewRoles([]);
      setComment("");
    }
  }
  let popoverNode = /*#__PURE__*/React.createRef();
  function onChangeEmail(e) {
    var _Utils$normalizeEmail;
    const value = (_Utils$normalizeEmail = Utils.normalizeEmail(e.target.value)) != null ? _Utils$normalizeEmail : "";
    setEmail(value);
    const message = Utils.isEmail(value) ? "The email is good" : "This doesn't look valid";
    setEmailHelp(message);
  }

  // Check if View Only role is enabled via config
  const viewOnlyRoleConfig = orgConfig && orgConfig.find(oc => oc.id === "properties/viewOnlyRoleEnabled");
  const isViewOnlyRoleEnabled = viewOnlyRoleConfig ? viewOnlyRoleConfig.value : false;

  // Filter roles based on config
  const allRoles = SecurityUtils.allRoles();
  const filteredRoles = isViewOnlyRoleEnabled ? allRoles : allRoles.filter(name => name !== "View Only");
  const [roleOptions, setRoleOptions] = React.useState(filteredRoles.map(name => ({
    value: name,
    label: name
  })));

  // Update roleOptions when config changes and remove View Only from selection if disabled
  React.useEffect(() => {
    const viewOnlyRoleConfig = orgConfig && orgConfig.find(oc => oc.id === "properties/viewOnlyRoleEnabled");
    const isViewOnlyRoleEnabled = viewOnlyRoleConfig ? viewOnlyRoleConfig.value : false;
    const roles = isViewOnlyRoleEnabled ? allRoles : allRoles.filter(name => name !== "View Only");
    const updatedRoleOptions = roles.map(name => ({
      value: name,
      label: name
    }));
    setRoleOptions(updatedRoleOptions);
  }, [orgConfig]);
  const selectStyles = makeStyles(theme => ({
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      "& input": {
        font: "inherit"
      },
      margin: 0
    }),
    dropdownIndicator: base => ({
      ...base,
      padding: "0",
      paddingLeft: "8px"
    }),
    clearIndicator: base => ({
      ...base,
      padding: "0 8px",
      paddingLeft: "8px"
    })
  }));
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle$1, {
    className: classes.header
  }, /*#__PURE__*/React.createElement("div", null, "Create New Team Member")), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    value: email,
    label: "Email",
    variant: "outlined",
    onChange: onChangeEmail,
    helperText: emailHelp
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    value: firstName,
    label: "First Name",
    variant: "outlined",
    onChange: e => setFirstName(e.target.value)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    value: lastName,
    label: "Last Name",
    variant: "outlined",
    onChange: e => setLastName(e.target.value)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, requireComment && /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    value: comment,
    label: "Comment",
    variant: "outlined",
    onChange: e => setComment(e.target.value),
    multiline: true,
    minRows: 2,
    style: {
      marginTop: 16
    },
    helperText: !comment.trim() ? "Comment is required" : ""
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(ReactSelect, {
    isMulti: true,
    name: "role",
    options: roleOptions,
    value: newRoles,
    onChange: e => {
      const selected = e != null ? e : [];
      if (selected.some(item => item.value === "View Only")) {
        const roles = filteredRoles.map(name => ({
          value: name,
          label: name,
          isDisabled: name === "View Only" ? false : true
        }));
        setNewRoles([{
          value: "View Only",
          label: "View Only"
        }]);
        setRoleOptions(roles);
      } else {
        const roles = filteredRoles.map(name => ({
          value: name,
          label: name,
          isDisabled: false
        }));
        setNewRoles(selected);
        setRoleOptions(roles);
      }
    },
    isClearable: true,
    isSearchable: false,
    classes: classes,
    styles: selectStyles,
    components: {
      ...components
    },
    textFieldProps: {
      required: false,
      label: "Role",
      inputRef: popoverNode,
      InputLabelProps: {
        shrink: shrinkLabel || newRoles && newRoles.length === 0 ? false : true
      },
      onChange: event => {
        event.target.value && event.target.value.length > 0 ? setShrinkLabel(true) : setShrinkLabel(false);
      }
    },
    popoverNode: popoverNode,
    placeholder: ""
  })))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    onClick: () => onClose()
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: loading || disabled,
    onClick: onInvite
  }, "Invite")));
}
InvitationForm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  requireComment: PropTypes.bool,
  orgConfig: PropTypes.array
};

const orgStyles = theme => ({
  orgTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(24),
    fontWeight: theme.typography.fontWeightRegular
  },
  portalDashboardPageWrapper: {
    padding: "24px",
    minHeight: "100%",
    boxSizing: "border-box"
  },
  media: {
    maxWidth: "100%"
  },
  button: {
    "& svg": {
      marginRight: theme.spacing(1)
    }
  },
  root: {
    display: "flex",
    backgroundColor: theme.palette.background.paper,
    height: "70vh"
  },
  buttonRoot: {
    display: "flex",
    alignItems: "center"
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    color: lightBlue[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  periodButtons: {
    "& svg": {
      marginRight: theme.spacing(1)
    }
  },
  orgActions: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 24,
    paddingRight: 16,
    marginLeft: 8
  },
  orgLogo: {
    width: 64,
    height: 64,
    objectFit: "cover"
  },
  orgContainer: {
    padding: 0
  },
  hide: {
    display: "none"
  }
});
function Organization$1(props) {
  const [logoSrc, setLogoSrc] = React.useState();
  const [showInvite, setShowInvite] = React.useState(false);
  const {
    currentOrganization,
    organizationUserLicenses,
    currentUser,
    onInvite,
    classes,
    updateOrganizationAttribute,
    organizationUsers,
    revEssential
  } = props;
  React.useEffect(() => {
    if (currentOrganization) {
      setLogoSrc(`https://logo.clearbit.com/${currentOrganization.domain}`);
    }
  }, [currentOrganization]);
  async function onEditOrgName(n) {
    currentOrganization.name = n;
    if (updateOrganizationAttribute) {
      try {
        await updateOrganizationAttribute(currentOrganization.id, {
          name: n
        });
      } catch (e) {
        await showAlert({
          title: "Failed to update",
          text: e.errorMessage || `Unable to update with the name ${n}`,
          buttons: true,
          icon: "error"
        });
      }
    }
  }
  function getInternalUsers(organizationUsers) {
    let internalUserCount = 0;
    for (let user of organizationUsers) {
      if (SecurityUtils.isInternalUser(user)) {
        internalUserCount++;
      }
    }
    return internalUserCount;
  }
  const remainingSeats = React.useMemo(() => organizationUserLicenses ? Number(organizationUserLicenses.maxUserSeats) - Number(organizationUserLicenses.activeUsersSeats) + Number(getInternalUsers(organizationUsers)) : 0, [organizationUserLicenses]);
  React.useMemo(() => organizationUserLicenses ? organizationUserLicenses.maxAdvancedSeats - organizationUserLicenses.activeAdvancedSeats : 0, [organizationUserLicenses]);
  if (!currentOrganization) return null;
  const isAdmin = SecurityUtils.hasRole(currentOrganization.id, "Admin", currentUser);
  const canAddSeats = isAdmin && currentOrganization && !currentOrganization.isReadOnly;
  const {
    label,
    description
  } = SecurityUtils.getPlan(currentOrganization);
  return /*#__PURE__*/React.createElement(Paper$1, {
    elevation: 1,
    className: classes.orgContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center"
  }, props.tab == 0 && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    style: {
      paddingLeft: 15
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: "font-semibold",
    variant: "h6"
  }, "Team Members")), props.tab == 1 && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2
  }, /*#__PURE__*/React.createElement("img", {
    src: logoSrc,
    onError: () => setLogoSrc("https://cdn.revrec.chargebee.com/images/defaultOrgIcon.png"),
    className: classes.orgLogo
  })), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justify: "flex-start"
  }, /*#__PURE__*/React.createElement(EditableLabel, {
    inputWidth: "220px",
    labelClassName: classes.orgTitle,
    inputClassName: classes.orgTitle,
    text: currentOrganization.name,
    onFocusOut: onEditOrgName
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justify: "flex-start",
    mt: 0.5,
    onClick: () => window.open("https://rev-lock.com/pricing", "_blank")
  }, /*#__PURE__*/React.createElement(PolicyOutlined, {
    fontSize: "small"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      paddingLeft: 4
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, label), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, description)))))), canAddSeats && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.orgActions
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justify: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    id: "inviteMembers",
    style: {
      color: "white"
    },
    onClick: () => setShowInvite(true),
    className: props.tab == "1" ? `${classes.hide} ${classes.button}` : `${classes.button}`,
    disabled: remainingSeats <= 0 ? true : isImpersonatedUser(),
    startIcon: /*#__PURE__*/React.createElement(People, null)
  }, "Invite Members"), /*#__PURE__*/React.createElement(Typography, {
    className: props.tab == "1" && `${classes.hide}`,
    variant: "caption",
    style: {
      marginTop: 4
    }
  }, remainingSeats < 0 ? 0 : remainingSeats, " ", "seats available")), props.tab == "1" && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justify: "left",
    ml: 1.5,
    alignItems: "left"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    disabled: props.disableClearEnvironment || isImpersonatedUser(),
    onClick: evt => licensedExecute({
      type: "plan",
      name: "rev-up"
    }, props.onDelete),
    color: "secondary",
    startIcon: /*#__PURE__*/React.createElement(DeleteForeverSharp, null),
    style: {
      color: "white",
      minWidth: 175
    },
    className: classes.button
  }, "Clear Environment"))))), /*#__PURE__*/React.createElement(InvitationForm, {
    open: showInvite,
    onClose: () => setShowInvite(false),
    onSave: onInvite,
    orgConfig: props.orgConfig
  }));
}
Organization$1.propTypes = {
  currentOrganization: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  organizationUserLicenses: PropTypes.object.isRequired,
  onInvite: PropTypes.func.isRequired
};
var Organization$2 = withStyles(orgStyles, {
  theme: true
})(Organization$1);

function Roles(props) {
  const {
    currentOrganization,
    user,
    classes,
    isAdmin,
    orgConfig
  } = props;
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [roles, setRoles] = React.useState([]);

  // Check if View Only role is enabled via config
  const viewOnlyRoleConfig = orgConfig && orgConfig.find(oc => oc.id === "properties/viewOnlyRoleEnabled");
  const isViewOnlyRoleEnabled = viewOnlyRoleConfig ? viewOnlyRoleConfig.value : false;

  // Filter roles based on config
  const allRoles = SecurityUtils.allRoles();
  const filteredRoles = isViewOnlyRoleEnabled ? allRoles : allRoles.filter(name => name !== "View Only");
  React.useEffect(() => {
    const authorizations = user.authorizations.find(auth => auth.org === currentOrganization.id);
    setRoles(authorizations.roles);
  }, [user]);
  async function handleRoleUpdate(e) {
    let newRoles = e.target.value;
    const authorizations = user.authorizations.find(auth => auth.org == currentOrganization.id);
    const originalRoles = authorizations.roles;
    const currentRoles = roles;
    const isViewOnlySelected = newRoles.includes("View Only");
    const wasViewOnlySelected = currentRoles.includes("View Only");

    // If View Only is being selected, unselect all other roles
    if (isViewOnlySelected && !wasViewOnlySelected) {
      newRoles = ["View Only"];
    }
    // If any other role is being selected and View Only is currently selected, unselect View Only
    else if (!isViewOnlySelected && wasViewOnlySelected && newRoles.length > 0) {
      // Remove View Only from the selection
      newRoles = newRoles.filter(role => role !== "View Only");
    }
    if (originalRoles.includes("Admin") && !newRoles.includes("Admin")) {
      const loseAdmin = await swal({
        title: "Are you sure?",
        text: `This will disable your admin access and hence you will no longer be able to make role updates`,
        icon: "warning",
        dangerMode: true,
        buttons: true
      });
      if (!loseAdmin) {
        return;
      }
    }
    setRoles(newRoles);
  }
  async function updateRoles(user) {
    const {
      onUpdateUser,
      currentOrganization
    } = props;
    const authorizations = user.authorizations.find(auth => auth.org == currentOrganization.id);
    const originalRoles = authorizations.roles;
    function hasChange(as, bs) {
      if (as.length !== bs.length) return true;
      for (let a of as) if (!bs.includes(a)) return true;
      return false;
    }
    if (hasChange(roles, originalRoles)) {
      try {
        setLoading(true);
        await onUpdateUser(user, roles, null, () => {
          setLoading(false);
          setOpen(false);
        });
      } catch (e) {
        await showAlert({
          title: "Failed to update",
          text: `We were unable to update the user's role ${e}`,
          buttons: true,
          icon: "error"
        });
      }
    }
  }
  if (isAdmin) return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.formControl,
    style: {
      width: "100%"
    },
    disabled: loading
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "select-multiple"
  }, "Roles"), /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    value: roles,
    open: open,
    onClose: () => setOpen(false),
    onOpen: () => setOpen(true),
    onChange: handleRoleUpdate,
    input: /*#__PURE__*/React.createElement(Input, {
      id: "select-multiple"
    }),
    renderValue: selected => selected.join(", "),
    disabled: loading || currentOrganization && currentOrganization.isReadOnly
  }, loading && /*#__PURE__*/React.createElement(LinearProgress, null), filteredRoles.map(name => {
    const isViewOnlySelected = roles.includes("View Only");
    const isViewOnly = name === "View Only";
    const isDisabled = isViewOnlySelected && !isViewOnly;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: name,
      value: name,
      disabled: isDisabled
    }, /*#__PURE__*/React.createElement(Checkbox, {
      color: "primary",
      checked: roles.indexOf(name) > -1,
      disabled: isDisabled
    }), /*#__PURE__*/React.createElement(ListItemText$1, {
      primary: name
    }));
  }), /*#__PURE__*/React.createElement(Button, {
    disabled: loading || !roles.length || isImpersonatedUser(),
    className: classes.button,
    type: "submit",
    variant: "contained",
    color: "primary",
    onClick: () => updateRoles(user)
  }, "Save"))));else {
    return roles.map(role => /*#__PURE__*/React.createElement(Chip, {
      key: role,
      label: role,
      className: classes.chip
    }));
  }
}

const userTableStyles = theme => ({
  tableCell: {
    padding: "6px 24px 8px 24px"
  },
  chip: {
    marginRight: theme.spacing(1) / 4
  },
  root: {
    padding: theme.spacing(1),
    alignItems: "center",
    color: "white",
    minHeight: "48px"
  },
  title: {
    flex: "0 0 auto",
    paddingLeft: 8,
    color: "black",
    height: "100%",
    alignItems: "center",
    display: "flex"
  },
  button: {
    float: "right",
    margin: "0px 5px 5px 0px"
  }
});
const columnData = (isAdmin, currentOrganization) => {
  let column = [{
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name"
  }, {
    id: "roles",
    numeric: false,
    disablePadding: false,
    label: "Roles"
  }, {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email"
  }];
  if (currentOrganization && !currentOrganization.isReadOnly) column.push({
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Actions"
  });
  return column;
};
class UserTable extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onUpdateNotificationPreferences = async (user, notificationsDisabled) => {
      const {
        onUpdateUser
      } = this.props;
      try {
        await onUpdateUser(user, null, notificationsDisabled);
      } catch (e) {
        await showAlert({
          title: "Failed to update",
          text: `We were unable to update the user's notification preferences ${e}`,
          buttons: true,
          icon: "error"
        });
      }
    };
    this.state = {
      order: "asc",
      orderBy: "revenue",
      organizationUsers: Utils.cloneDeep(props.organizationUsers),
      newRoles: ["Admin"]
    };
  }
  componentWillReceiveProps(newProps) {
    if (newProps.organizationUsers !== this.props.organizationUsers) {
      this.setState({
        organizationUsers: newProps.organizationUsers
      });
    }
  }
  render() {
    const {
      orderBy,
      order,
      organizationUsers
    } = this.state;
    const {
      classes,
      currentOrganization,
      currentUser,
      onRemoveUser,
      onUpdateUser,
      orgConfig
    } = this.props;
    const isAdmin = SecurityUtils.hasRole(currentOrganization.id, "Admin", currentUser);
    if (!currentUser || !currentOrganization || !organizationUsers) return null;
    const sortHandler = property => event => {
      //TODO: fix me
    };
    function areNotificationsEnabled(user) {
      if (!user.preferences || !user.preferences[currentOrganization.id] || !user.preferences[currentOrganization.id].notificationsDisabled) return true;
      //if not disabled then it is enabled

      return !user.preferences[currentOrganization.id].notificationsDisabled;
    }

    /**
     * Disable if I am not an admin OR it is my own account
     */
    function canRemoveUser(user) {
      var _currentUser$attribut;
      return !isAdmin || (currentUser == null || (_currentUser$attribut = currentUser.attributes) == null ? void 0 : _currentUser$attribut.email) === user.email;
    }

    /**
     * If this is my account OR I am an admin I can change prefs otherwise I cant
     */
    function canUpdatePrefs(user) {
      var _currentUser$attribut2;
      return !(isAdmin || (currentUser == null || (_currentUser$attribut2 = currentUser.attributes) == null ? void 0 : _currentUser$attribut2.email) === user.email);
    }
    const columns = columnData(isAdmin, currentOrganization);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, columns.map(column => /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableCell,
      sortDirection: orderBy === column.id ? order : false,
      align: column.numeric ? "right" : "inherit",
      padding: column.disablePadding ? "none" : "default"
    }, /*#__PURE__*/React.createElement(TableSortLabel, {
      active: orderBy === column.id,
      direction: order,
      onClick: sortHandler(column.id)
    }, /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      noWrap: true,
      variant: "body1"
    }, " ", column.label)))))), /*#__PURE__*/React.createElement(TableBody, null, organizationUsers.map(user => {
      var _currentUser$attribut3;
      return (!SecurityUtils.isInternalUser(user) || SecurityUtils.isInternalUser({
        email: currentUser == null || (_currentUser$attribut3 = currentUser.attributes) == null ? void 0 : _currentUser$attribut3.email
      })) && /*#__PURE__*/React.createElement(TableRow, {
        key: user.id
      }, /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell
      }, user.firstName ? user.firstName + " " + user.lastName : user.email), /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell
      }, /*#__PURE__*/React.createElement(Roles, {
        currentOrganization: currentOrganization,
        user: user,
        isAdmin: isAdmin,
        classes: classes,
        orgConfig: orgConfig,
        onUpdateUser: onUpdateUser
      })), /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell
      }, user.email), !(currentOrganization != null && currentOrganization.isReadOnly) && /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: `Disable/Enable Notifications`
      }, /*#__PURE__*/React.createElement(Switch, {
        disabled: canUpdatePrefs(user) || isImpersonatedUser(),
        checked: areNotificationsEnabled(user),
        onChange: e => this.onUpdateNotificationPreferences(user, !e.target.checked),
        color: "primary",
        inputProps: {
          "aria-label": "primary checkbox"
        }
      })), /*#__PURE__*/React.createElement(Tooltip, {
        title: `Remove team member access`
      }, /*#__PURE__*/React.createElement(IconButton, {
        color: "primary",
        disabled: canRemoveUser(user) || isImpersonatedUser(),
        onClick: () => onRemoveUser(user)
      }, /*#__PURE__*/React.createElement(Delete, null)))));
    }))));
  }
}
UserTable.propTypes = {
  currentOrganization: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  organizationUsers: PropTypes.array.isRequired,
  organizationUserLicenses: PropTypes.object.isRequired,
  orgUserStatus: PropTypes.object.isRequired,
  onRemoveUser: PropTypes.func.isRequired,
  onUpdateUser: PropTypes.func.isRequired
};
var UsersTable = withStyles(userTableStyles, {
  withTheme: true
})(UserTable);

function Users(props) {
  const {
    organizationUsers,
    organizationUserLicenses,
    currentOrganization,
    isAdmin,
    orgUsersStatus,
    currentUser,
    orgConfig
  } = props;
  const {
    onRemove,
    onUpdateUser
  } = props;
  const onRemoveUser = async user => {
    const willRemove = await showAlert({
      title: "Remove from organization",
      text: "Are you sure you want to remove " + user.email + " from this organization?",
      icon: "warning",
      dangerMode: true,
      buttons: true
    });
    if (!willRemove) return;
    onRemove(user);
    //remove the user from the organization.. ? what happens to them?
  };
  if (!organizationUserLicenses) return null;
  if (!organizationUsers || orgUsersStatus && orgUsersStatus.loading && !orgUsersStatus.hasLoadedBefore) return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "100%",
      height: "20vh",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, null)));
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(UsersTable, {
    isAdmin: isAdmin,
    currentOrganization: currentOrganization,
    currentUser: currentUser,
    organizationUsers: organizationUsers,
    onRemoveUser: user => onRemoveUser(user),
    onUpdateUser: onUpdateUser,
    orgConfig: orgConfig
  })));
}
Users.propTypes = {
  currentOrganization: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  organizationUsers: PropTypes.object.isRequired,
  organizationUserLicenses: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  orgUserStatus: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdateUser: PropTypes.func.isRequired
};

function has(value) {
  return value !== undefined && value !== null && value !== "";
}
const useCreateOrgStyles = makeStyles(theme => ({
  header: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '400 !important',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    backgroundColor: theme.palette.primary.main
  },
  title: {
    color: 'white'
  },
  alert: {
    marginBottom: theme.spacing(3)
  }
}));
function CreateOrganization(props) {
  const [company, setCompany] = React.useState("");
  const [website, setWebsite] = React.useState("");
  const [contactName, setContactName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const {
    onSave,
    open,
    onClose
  } = props;
  const classes = useCreateOrgStyles();
  const create = async () => {
    setError(null);
    if (!has(company)) {
      setError({
        code: 'MISSING_VALUE',
        message: 'We need your company name.'
      });
      return;
    }
    if (!has(website) || !Utils.isDomain(website)) {
      setError({
        code: 'INVALID_WEBSITE',
        message: 'The supplied website doesn\'t look right.'
      });
      return;
    }
    if (has(email) && !Utils.isEmail(email)) {
      setError({
        code: 'INVALID_EMAIL',
        message: 'We need a valid email address'
      });
      return;
    }
    if (has(phone) && !Utils.isPhone(phone)) {
      setError({
        code: 'INVALID_PHONE',
        message: 'The phone # appears to be invalid.'
      });
      return;
    }
    try {
      setLoading(true);
      await onSave(company, website, contactName, email, phone);
    } catch (e) {
      const message = e.errorMessage || e.toString();
      await showAlert({
        title: 'Failed to create',
        text: `We were unable to create a company with the domain ${website} ${message}`,
        buttons: true,
        icon: 'error'
      });
    } finally {
      setLoading(false);
      setContactName("");
      setPhone("");
      setEmail("");
      setCompany("");
      setWebsite("");
      onClose();
    }
  };
  const handlePhone = value => {
    // replace All not supported into old version browsers
    const inputPhone = value && value.replace(/\s+|\(|\)|\-/g, "");
    setPhone(inputPhone);
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle$1, {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.title
  }, "Add a company")), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, loading && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(LinearProgress, null)), error && error.message && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    className: classes.alert
  }, /*#__PURE__*/React.createElement(AlertTitle, null, error.message))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: 'outlined',
    label: "Company Name",
    fullWidth: true,
    margin: "dense",
    value: company,
    key: "company",
    name: "company",
    onChange: e => setCompany(e.target.value),
    inputProps: {
      autoFocus: true
    },
    helperText: 'Name of the customer'
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: 'outlined',
    value: website,
    label: "Website",
    fullWidth: true,
    margin: "dense",
    key: "website",
    name: "website",
    onChange: e => setWebsite(e.target.value),
    inputProps: {
      autoFocus: true
    },
    helperText: 'Unique domain name for customer'
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: 'outlined',
    label: "Contact Name",
    fullWidth: true,
    margin: "dense",
    value: contactName,
    onChange: e => setContactName(e.target.value)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: 'outlined',
    label: "Contact Email",
    value: email,
    fullWidth: true,
    margin: "dense",
    key: "username",
    name: "username",
    onChange: e => setEmail(e.target.value)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
    variant: 'outlined',
    label: "Contact Phone Number",
    margin: "dense",
    fullWidth: true,
    defaultCountry: 'us',
    onChange: handlePhone
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    display: 'flex',
    justifyContent: 'space-between'
  }, /*#__PURE__*/React.createElement(Button, {
    variant: 'outlined',
    onClick: onClose,
    color: "disabled"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: 'contained',
    onClick: create,
    color: "primary"
  }, "Save")))))));
}
CreateOrganization.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

const useEnvStyles = makeStyles(theme => ({
  cardHeader: {
    paddingTop: 24
  },
  cardContent: {
    padding: "0 16px 16px !important"
  },
  card: {
    margin: theme.spacing(0.5)
  }
}));
const SmallAvatar = withStyles(theme => ({
  root: {
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`
  }
}))(Avatar);
function Organization(props) {
  const {
    org,
    onSwitch,
    envLength
  } = props;
  const [logoSrc, setLogoSrc] = React.useState(`https://logo.clearbit.com/${org.domain}`);
  const classes = useEnvStyles();
  const accountCreated = React.useMemo(() => {
    if (!org.createdOn) return "N/A";
    return moment(org.createdOn).fromNow();
  }, [org.createdOn]);
  const isTestOrg = new String(org.id).startsWith(9);
  const badgeContent = isTestOrg ? /*#__PURE__*/React.createElement(SmallAvatar, {
    src: "https://cdn.revrec.chargebee.com/images/flask.svg",
    style: {
      backgroundColor: "white"
    }
  }) : null;
  const activeUserMessage = React.useMemo(() => {
    if (!org.users) return "No active users";
    return `${org.users.length} users`;
  }, [org.users]);
  if (!org) return null;
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: classes.cardHeader,
    avatar: /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(Avatar, null, /*#__PURE__*/React.createElement(Badge, {
      overlap: "circle",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      badgeContent: badgeContent
    }, !badgeContent && /*#__PURE__*/React.createElement("img", {
      src: logoSrc,
      onError: () => setLogoSrc("https://cdn.revrec.chargebee.com/images/defaultOrgIcon.png"),
      width: 60,
      height: 60,
      alt: "Logo"
    })))),
    title: `${org.name} (${org.id})`,
    subheader: `Joined ${accountCreated} with domain ${org.merchantId ? org.merchantId : "N/A"}`
  }), /*#__PURE__*/React.createElement(CardContent, {
    className: classes.cardContent
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, activeUserMessage), envLength > 1 && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: () => onSwitch(org.id)
  }, "Switch To")))));
}
function Environments(props) {
  const {
    environments,
    onCreate,
    partnerMax,
    isPartner
  } = props;
  const [showCreate, setShowCreate] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0
  }, isPartner && partnerMax > environments.length && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "flex-end",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Add new environment"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => setShowCreate(true)
  }, /*#__PURE__*/React.createElement(Add, null))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, environments.map(org => /*#__PURE__*/React.createElement(Organization, _extends({}, props, {
    org: org,
    envLength: environments.length
  }))))), /*#__PURE__*/React.createElement(CreateOrganization, {
    open: showCreate,
    onClose: () => setShowCreate(false),
    onSave: onCreate
  }));
}
Environments.propTypes = {
  partnerMax: PropTypes.number.isRequired,
  environments: PropTypes.array.isRequired,
  onCreate: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired
};

export { ConfirmSignIn$1 as ConfirmSignIn, ConfirmSignUp$1 as ConfirmSignUp, Environments, ForgotPassword$1 as ForgotPassword, InvitationForm, Organization$2 as Organization, Profile$1 as Profile, RequireNewPassword$1 as RequireNewPassword, SignIn$1 as SignIn, SignUp$1 as SignUp, Users, VerifyContact$1 as VerifyContact };
